/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApolloDocumentDTO } from '../model/apolloDocumentDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApolloDocumentResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countApolloDocuments
     * 
     * @param capContains 
     * @param capDoesNotContain 
     * @param capEquals 
     * @param capIn 
     * @param capNotEquals 
     * @param capSpecified 
     * @param cittContains 
     * @param cittDoesNotContain 
     * @param cittEquals 
     * @param cittIn 
     * @param cittNotEquals 
     * @param cittSpecified 
     * @param clienteEquals 
     * @param clienteIn 
     * @param clienteNotEquals 
     * @param clienteSpecified 
     * @param codfiscContains 
     * @param codfiscDoesNotContain 
     * @param codfiscEquals 
     * @param codfiscIn 
     * @param codfiscNotEquals 
     * @param codfiscSpecified 
     * @param codiceInvioContains 
     * @param codiceInvioDoesNotContain 
     * @param codiceInvioEquals 
     * @param codiceInvioIn 
     * @param codiceInvioNotEquals 
     * @param codiceInvioSpecified 
     * @param contoEquals 
     * @param contoGreaterThan 
     * @param contoGreaterThanOrEqual 
     * @param contoIn 
     * @param contoLessThan 
     * @param contoLessThanOrEqual 
     * @param contoNotEquals 
     * @param contoSpecified 
     * @param contrintegpercEquals 
     * @param contrintegpercGreaterThan 
     * @param contrintegpercGreaterThanOrEqual 
     * @param contrintegpercIn 
     * @param contrintegpercLessThan 
     * @param contrintegpercLessThanOrEqual 
     * @param contrintegpercNotEquals 
     * @param contrintegpercSpecified 
     * @param contrintegvalEquals 
     * @param contrintegvalGreaterThan 
     * @param contrintegvalGreaterThanOrEqual 
     * @param contrintegvalIn 
     * @param contrintegvalLessThan 
     * @param contrintegvalLessThanOrEqual 
     * @param contrintegvalNotEquals 
     * @param contrintegvalSpecified 
     * @param dataEquals 
     * @param dataGreaterThan 
     * @param dataGreaterThanOrEqual 
     * @param dataIn0ChronologyCalendarType 
     * @param dataIn0ChronologyId 
     * @param dataIn0DayOfMonth 
     * @param dataIn0DayOfWeek 
     * @param dataIn0DayOfYear 
     * @param dataIn0EraValue 
     * @param dataIn0LeapYear 
     * @param dataIn0Month 
     * @param dataIn0MonthValue 
     * @param dataIn0Year 
     * @param dataLessThan 
     * @param dataLessThanOrEqual 
     * @param dataNotEquals 
     * @param dataSpecified 
     * @param datainsEquals 
     * @param datainsGreaterThan 
     * @param datainsGreaterThanOrEqual 
     * @param datainsIn0DayOfMonth 
     * @param datainsIn0DayOfWeek 
     * @param datainsIn0DayOfYear 
     * @param datainsIn0Hour 
     * @param datainsIn0Minute 
     * @param datainsIn0Month 
     * @param datainsIn0MonthValue 
     * @param datainsIn0Nano 
     * @param datainsIn0OffsetId 
     * @param datainsIn0OffsetRulesFixedOffset 
     * @param datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator 
     * @param datainsIn0OffsetRulesTransitionRules0DayOfWeek 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeHour 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeMinute 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeNano 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeSecond 
     * @param datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay 
     * @param datainsIn0OffsetRulesTransitionRules0Month 
     * @param datainsIn0OffsetRulesTransitionRules0TimeDefinition 
     * @param datainsIn0OffsetRulesTransitions0DateTimeAfter 
     * @param datainsIn0OffsetRulesTransitions0DateTimeBefore 
     * @param datainsIn0OffsetRulesTransitions0DurationNano 
     * @param datainsIn0OffsetRulesTransitions0DurationNegative 
     * @param datainsIn0OffsetRulesTransitions0DurationSeconds 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0DateBased 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased 
     * @param datainsIn0OffsetRulesTransitions0DurationZero 
     * @param datainsIn0OffsetRulesTransitions0Gap 
     * @param datainsIn0OffsetRulesTransitions0Instant 
     * @param datainsIn0OffsetRulesTransitions0Overlap 
     * @param datainsIn0OffsetTotalSeconds 
     * @param datainsIn0Second 
     * @param datainsIn0Year 
     * @param datainsIn0ZoneId 
     * @param datainsIn0ZoneRulesFixedOffset 
     * @param datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator 
     * @param datainsIn0ZoneRulesTransitionRules0DayOfWeek 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeHour 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeMinute 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeNano 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeSecond 
     * @param datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay 
     * @param datainsIn0ZoneRulesTransitionRules0Month 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetAfterId 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetBeforeId 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0StandardOffsetId 
     * @param datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0TimeDefinition 
     * @param datainsIn0ZoneRulesTransitions0DateTimeAfter 
     * @param datainsIn0ZoneRulesTransitions0DateTimeBefore 
     * @param datainsIn0ZoneRulesTransitions0DurationNano 
     * @param datainsIn0ZoneRulesTransitions0DurationNegative 
     * @param datainsIn0ZoneRulesTransitions0DurationSeconds 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0DateBased 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased 
     * @param datainsIn0ZoneRulesTransitions0DurationZero 
     * @param datainsIn0ZoneRulesTransitions0Gap 
     * @param datainsIn0ZoneRulesTransitions0Instant 
     * @param datainsIn0ZoneRulesTransitions0OffsetAfterId 
     * @param datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds 
     * @param datainsIn0ZoneRulesTransitions0OffsetBeforeId 
     * @param datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds 
     * @param datainsIn0ZoneRulesTransitions0Overlap 
     * @param datainsLessThan 
     * @param datainsLessThanOrEqual 
     * @param datainsNotEquals 
     * @param datainsSpecified 
     * @param dataregistrazioneEquals 
     * @param dataregistrazioneGreaterThan 
     * @param dataregistrazioneGreaterThanOrEqual 
     * @param dataregistrazioneIn0ChronologyCalendarType 
     * @param dataregistrazioneIn0ChronologyId 
     * @param dataregistrazioneIn0DayOfMonth 
     * @param dataregistrazioneIn0DayOfWeek 
     * @param dataregistrazioneIn0DayOfYear 
     * @param dataregistrazioneIn0EraValue 
     * @param dataregistrazioneIn0LeapYear 
     * @param dataregistrazioneIn0Month 
     * @param dataregistrazioneIn0MonthValue 
     * @param dataregistrazioneIn0Year 
     * @param dataregistrazioneLessThan 
     * @param dataregistrazioneLessThanOrEqual 
     * @param dataregistrazioneNotEquals 
     * @param dataregistrazioneSpecified 
     * @param fornitoreEquals 
     * @param fornitoreIn 
     * @param fornitoreNotEquals 
     * @param fornitoreSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param idanagraficaEquals 
     * @param idanagraficaGreaterThan 
     * @param idanagraficaGreaterThanOrEqual 
     * @param idanagraficaIn 
     * @param idanagraficaLessThan 
     * @param idanagraficaLessThanOrEqual 
     * @param idanagraficaNotEquals 
     * @param idanagraficaSpecified 
     * @param idaziendaEquals 
     * @param idaziendaGreaterThan 
     * @param idaziendaGreaterThanOrEqual 
     * @param idaziendaIn 
     * @param idaziendaLessThan 
     * @param idaziendaLessThanOrEqual 
     * @param idaziendaNotEquals 
     * @param idaziendaSpecified 
     * @param iddocumentoContains 
     * @param iddocumentoDoesNotContain 
     * @param iddocumentoEquals 
     * @param iddocumentoIn 
     * @param iddocumentoNotEquals 
     * @param iddocumentoSpecified 
     * @param idsottocontoContains 
     * @param idsottocontoDoesNotContain 
     * @param idsottocontoEquals 
     * @param idsottocontoIn 
     * @param idsottocontoNotEquals 
     * @param idsottocontoSpecified 
     * @param indirizzoContains 
     * @param indirizzoDoesNotContain 
     * @param indirizzoEquals 
     * @param indirizzoIn 
     * @param indirizzoNotEquals 
     * @param indirizzoSpecified 
     * @param intestazioneContains 
     * @param intestazioneDoesNotContain 
     * @param intestazioneEquals 
     * @param intestazioneIn 
     * @param intestazioneNotEquals 
     * @param intestazioneSpecified 
     * @param ivaEquals 
     * @param ivaGreaterThan 
     * @param ivaGreaterThanOrEqual 
     * @param ivaIn 
     * @param ivaLessThan 
     * @param ivaLessThanOrEqual 
     * @param ivaNotEquals 
     * @param ivaSpecified 
     * @param ivasinoEquals 
     * @param ivasinoIn 
     * @param ivasinoNotEquals 
     * @param ivasinoSpecified 
     * @param mdopagEquals 
     * @param mdopagGreaterThan 
     * @param mdopagGreaterThanOrEqual 
     * @param mdopagIn 
     * @param mdopagLessThan 
     * @param mdopagLessThanOrEqual 
     * @param mdopagNotEquals 
     * @param mdopagSpecified 
     * @param ndocContains 
     * @param ndocDoesNotContain 
     * @param ndocEquals 
     * @param ndocIn 
     * @param ndocNotEquals 
     * @param ndocSpecified 
     * @param ndocSuffEquals 
     * @param ndocSuffGreaterThan 
     * @param ndocSuffGreaterThanOrEqual 
     * @param ndocSuffIn 
     * @param ndocSuffLessThan 
     * @param ndocSuffLessThanOrEqual 
     * @param ndocSuffNotEquals 
     * @param ndocSuffSpecified 
     * @param noteContains 
     * @param noteDoesNotContain 
     * @param noteEquals 
     * @param noteIn 
     * @param noteNotEquals 
     * @param noteSpecified 
     * @param opeinsContains 
     * @param opeinsDoesNotContain 
     * @param opeinsEquals 
     * @param opeinsIn 
     * @param opeinsNotEquals 
     * @param opeinsSpecified 
     * @param pecContains 
     * @param pecDoesNotContain 
     * @param pecEquals 
     * @param pecIn 
     * @param pecNotEquals 
     * @param pecSpecified 
     * @param percentIvaEquals 
     * @param percentIvaGreaterThan 
     * @param percentIvaGreaterThanOrEqual 
     * @param percentIvaIn 
     * @param percentIvaLessThan 
     * @param percentIvaLessThanOrEqual 
     * @param percentIvaNotEquals 
     * @param percentIvaSpecified 
     * @param percritenutaEquals 
     * @param percritenutaGreaterThan 
     * @param percritenutaGreaterThanOrEqual 
     * @param percritenutaIn 
     * @param percritenutaLessThan 
     * @param percritenutaLessThanOrEqual 
     * @param percritenutaNotEquals 
     * @param percritenutaSpecified 
     * @param pivaContains 
     * @param pivaDoesNotContain 
     * @param pivaEquals 
     * @param pivaIn 
     * @param pivaNotEquals 
     * @param pivaSpecified 
     * @param protSuffEquals 
     * @param protSuffGreaterThan 
     * @param protSuffGreaterThanOrEqual 
     * @param protSuffIn 
     * @param protSuffLessThan 
     * @param protSuffLessThanOrEqual 
     * @param protSuffNotEquals 
     * @param protSuffSpecified 
     * @param protocolloEquals 
     * @param protocolloGreaterThan 
     * @param protocolloGreaterThanOrEqual 
     * @param protocolloIn 
     * @param protocolloLessThan 
     * @param protocolloLessThanOrEqual 
     * @param protocolloNotEquals 
     * @param protocolloSpecified 
     * @param provContains 
     * @param provDoesNotContain 
     * @param provEquals 
     * @param provIn 
     * @param provNotEquals 
     * @param provSpecified 
     * @param ritenutaEquals 
     * @param ritenutaGreaterThan 
     * @param ritenutaGreaterThanOrEqual 
     * @param ritenutaIn 
     * @param ritenutaLessThan 
     * @param ritenutaLessThanOrEqual 
     * @param ritenutaNotEquals 
     * @param ritenutaSpecified 
     * @param tipoContains 
     * @param tipoDoesNotContain 
     * @param tipoEquals 
     * @param tipoIn 
     * @param tipoNotEquals 
     * @param tipoSpecified 
     * @param totaleEquals 
     * @param totaleGreaterThan 
     * @param totaleGreaterThanOrEqual 
     * @param totaleIn 
     * @param totaleLessThan 
     * @param totaleLessThanOrEqual 
     * @param totaleNotEquals 
     * @param totaleSpecified 
     * @param totimponibileEquals 
     * @param totimponibileGreaterThan 
     * @param totimponibileGreaterThanOrEqual 
     * @param totimponibileIn 
     * @param totimponibileLessThan 
     * @param totimponibileLessThanOrEqual 
     * @param totimponibileNotEquals 
     * @param totimponibileSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



















































































































































































































































































































































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (capContains !== undefined && capContains !== null) {
            queryParameters = queryParameters.set('cap.contains', <any>capContains);
        }
        if (capDoesNotContain !== undefined && capDoesNotContain !== null) {
            queryParameters = queryParameters.set('cap.doesNotContain', <any>capDoesNotContain);
        }
        if (capEquals !== undefined && capEquals !== null) {
            queryParameters = queryParameters.set('cap.equals', <any>capEquals);
        }
        if (capIn) {
            capIn.forEach((element) => {
                queryParameters = queryParameters.append('cap.in', <any>element);
            })
        }
        if (capNotEquals !== undefined && capNotEquals !== null) {
            queryParameters = queryParameters.set('cap.notEquals', <any>capNotEquals);
        }
        if (capSpecified !== undefined && capSpecified !== null) {
            queryParameters = queryParameters.set('cap.specified', <any>capSpecified);
        }
        if (cittContains !== undefined && cittContains !== null) {
            queryParameters = queryParameters.set('citt.contains', <any>cittContains);
        }
        if (cittDoesNotContain !== undefined && cittDoesNotContain !== null) {
            queryParameters = queryParameters.set('citt.doesNotContain', <any>cittDoesNotContain);
        }
        if (cittEquals !== undefined && cittEquals !== null) {
            queryParameters = queryParameters.set('citt.equals', <any>cittEquals);
        }
        if (cittIn) {
            cittIn.forEach((element) => {
                queryParameters = queryParameters.append('citt.in', <any>element);
            })
        }
        if (cittNotEquals !== undefined && cittNotEquals !== null) {
            queryParameters = queryParameters.set('citt.notEquals', <any>cittNotEquals);
        }
        if (cittSpecified !== undefined && cittSpecified !== null) {
            queryParameters = queryParameters.set('citt.specified', <any>cittSpecified);
        }
        if (clienteEquals !== undefined && clienteEquals !== null) {
            queryParameters = queryParameters.set('cliente.equals', <any>clienteEquals);
        }
        if (clienteIn) {
            clienteIn.forEach((element) => {
                queryParameters = queryParameters.append('cliente.in', <any>element);
            })
        }
        if (clienteNotEquals !== undefined && clienteNotEquals !== null) {
            queryParameters = queryParameters.set('cliente.notEquals', <any>clienteNotEquals);
        }
        if (clienteSpecified !== undefined && clienteSpecified !== null) {
            queryParameters = queryParameters.set('cliente.specified', <any>clienteSpecified);
        }
        if (codfiscContains !== undefined && codfiscContains !== null) {
            queryParameters = queryParameters.set('codfisc.contains', <any>codfiscContains);
        }
        if (codfiscDoesNotContain !== undefined && codfiscDoesNotContain !== null) {
            queryParameters = queryParameters.set('codfisc.doesNotContain', <any>codfiscDoesNotContain);
        }
        if (codfiscEquals !== undefined && codfiscEquals !== null) {
            queryParameters = queryParameters.set('codfisc.equals', <any>codfiscEquals);
        }
        if (codfiscIn) {
            codfiscIn.forEach((element) => {
                queryParameters = queryParameters.append('codfisc.in', <any>element);
            })
        }
        if (codfiscNotEquals !== undefined && codfiscNotEquals !== null) {
            queryParameters = queryParameters.set('codfisc.notEquals', <any>codfiscNotEquals);
        }
        if (codfiscSpecified !== undefined && codfiscSpecified !== null) {
            queryParameters = queryParameters.set('codfisc.specified', <any>codfiscSpecified);
        }
        if (codiceInvioContains !== undefined && codiceInvioContains !== null) {
            queryParameters = queryParameters.set('codiceInvio.contains', <any>codiceInvioContains);
        }
        if (codiceInvioDoesNotContain !== undefined && codiceInvioDoesNotContain !== null) {
            queryParameters = queryParameters.set('codiceInvio.doesNotContain', <any>codiceInvioDoesNotContain);
        }
        if (codiceInvioEquals !== undefined && codiceInvioEquals !== null) {
            queryParameters = queryParameters.set('codiceInvio.equals', <any>codiceInvioEquals);
        }
        if (codiceInvioIn) {
            codiceInvioIn.forEach((element) => {
                queryParameters = queryParameters.append('codiceInvio.in', <any>element);
            })
        }
        if (codiceInvioNotEquals !== undefined && codiceInvioNotEquals !== null) {
            queryParameters = queryParameters.set('codiceInvio.notEquals', <any>codiceInvioNotEquals);
        }
        if (codiceInvioSpecified !== undefined && codiceInvioSpecified !== null) {
            queryParameters = queryParameters.set('codiceInvio.specified', <any>codiceInvioSpecified);
        }
        if (contoEquals !== undefined && contoEquals !== null) {
            queryParameters = queryParameters.set('conto.equals', <any>contoEquals);
        }
        if (contoGreaterThan !== undefined && contoGreaterThan !== null) {
            queryParameters = queryParameters.set('conto.greaterThan', <any>contoGreaterThan);
        }
        if (contoGreaterThanOrEqual !== undefined && contoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('conto.greaterThanOrEqual', <any>contoGreaterThanOrEqual);
        }
        if (contoIn) {
            contoIn.forEach((element) => {
                queryParameters = queryParameters.append('conto.in', <any>element);
            })
        }
        if (contoLessThan !== undefined && contoLessThan !== null) {
            queryParameters = queryParameters.set('conto.lessThan', <any>contoLessThan);
        }
        if (contoLessThanOrEqual !== undefined && contoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('conto.lessThanOrEqual', <any>contoLessThanOrEqual);
        }
        if (contoNotEquals !== undefined && contoNotEquals !== null) {
            queryParameters = queryParameters.set('conto.notEquals', <any>contoNotEquals);
        }
        if (contoSpecified !== undefined && contoSpecified !== null) {
            queryParameters = queryParameters.set('conto.specified', <any>contoSpecified);
        }
        if (contrintegpercEquals !== undefined && contrintegpercEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.equals', <any>contrintegpercEquals);
        }
        if (contrintegpercGreaterThan !== undefined && contrintegpercGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThan', <any>contrintegpercGreaterThan);
        }
        if (contrintegpercGreaterThanOrEqual !== undefined && contrintegpercGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThanOrEqual', <any>contrintegpercGreaterThanOrEqual);
        }
        if (contrintegpercIn) {
            contrintegpercIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegperc.in', <any>element);
            })
        }
        if (contrintegpercLessThan !== undefined && contrintegpercLessThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThan', <any>contrintegpercLessThan);
        }
        if (contrintegpercLessThanOrEqual !== undefined && contrintegpercLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThanOrEqual', <any>contrintegpercLessThanOrEqual);
        }
        if (contrintegpercNotEquals !== undefined && contrintegpercNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.notEquals', <any>contrintegpercNotEquals);
        }
        if (contrintegpercSpecified !== undefined && contrintegpercSpecified !== null) {
            queryParameters = queryParameters.set('contrintegperc.specified', <any>contrintegpercSpecified);
        }
        if (contrintegvalEquals !== undefined && contrintegvalEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.equals', <any>contrintegvalEquals);
        }
        if (contrintegvalGreaterThan !== undefined && contrintegvalGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThan', <any>contrintegvalGreaterThan);
        }
        if (contrintegvalGreaterThanOrEqual !== undefined && contrintegvalGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThanOrEqual', <any>contrintegvalGreaterThanOrEqual);
        }
        if (contrintegvalIn) {
            contrintegvalIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegval.in', <any>element);
            })
        }
        if (contrintegvalLessThan !== undefined && contrintegvalLessThan !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThan', <any>contrintegvalLessThan);
        }
        if (contrintegvalLessThanOrEqual !== undefined && contrintegvalLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThanOrEqual', <any>contrintegvalLessThanOrEqual);
        }
        if (contrintegvalNotEquals !== undefined && contrintegvalNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.notEquals', <any>contrintegvalNotEquals);
        }
        if (contrintegvalSpecified !== undefined && contrintegvalSpecified !== null) {
            queryParameters = queryParameters.set('contrintegval.specified', <any>contrintegvalSpecified);
        }
        if (dataEquals !== undefined && dataEquals !== null) {
            queryParameters = queryParameters.set('data.equals', <any>dataEquals);
        }
        if (dataGreaterThan !== undefined && dataGreaterThan !== null) {
            queryParameters = queryParameters.set('data.greaterThan', <any>dataGreaterThan);
        }
        if (dataGreaterThanOrEqual !== undefined && dataGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('data.greaterThanOrEqual', <any>dataGreaterThanOrEqual);
        }
        if (dataIn0ChronologyCalendarType !== undefined && dataIn0ChronologyCalendarType !== null) {
            queryParameters = queryParameters.set('data.in[0].chronology.calendarType', <any>dataIn0ChronologyCalendarType);
        }
        if (dataIn0ChronologyId !== undefined && dataIn0ChronologyId !== null) {
            queryParameters = queryParameters.set('data.in[0].chronology.id', <any>dataIn0ChronologyId);
        }
        if (dataIn0DayOfMonth !== undefined && dataIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfMonth', <any>dataIn0DayOfMonth);
        }
        if (dataIn0DayOfWeek !== undefined && dataIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfWeek', <any>dataIn0DayOfWeek);
        }
        if (dataIn0DayOfYear !== undefined && dataIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfYear', <any>dataIn0DayOfYear);
        }
        if (dataIn0EraValue !== undefined && dataIn0EraValue !== null) {
            queryParameters = queryParameters.set('data.in[0].era.value', <any>dataIn0EraValue);
        }
        if (dataIn0LeapYear !== undefined && dataIn0LeapYear !== null) {
            queryParameters = queryParameters.set('data.in[0].leapYear', <any>dataIn0LeapYear);
        }
        if (dataIn0Month !== undefined && dataIn0Month !== null) {
            queryParameters = queryParameters.set('data.in[0].month', <any>dataIn0Month);
        }
        if (dataIn0MonthValue !== undefined && dataIn0MonthValue !== null) {
            queryParameters = queryParameters.set('data.in[0].monthValue', <any>dataIn0MonthValue);
        }
        if (dataIn0Year !== undefined && dataIn0Year !== null) {
            queryParameters = queryParameters.set('data.in[0].year', <any>dataIn0Year);
        }
        if (dataLessThan !== undefined && dataLessThan !== null) {
            queryParameters = queryParameters.set('data.lessThan', <any>dataLessThan);
        }
        if (dataLessThanOrEqual !== undefined && dataLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('data.lessThanOrEqual', <any>dataLessThanOrEqual);
        }
        if (dataNotEquals !== undefined && dataNotEquals !== null) {
            queryParameters = queryParameters.set('data.notEquals', <any>dataNotEquals);
        }
        if (dataSpecified !== undefined && dataSpecified !== null) {
            queryParameters = queryParameters.set('data.specified', <any>dataSpecified);
        }
        if (datainsEquals !== undefined && datainsEquals !== null) {
            queryParameters = queryParameters.set('datains.equals', <any>datainsEquals.toISOString());
        }
        if (datainsGreaterThan !== undefined && datainsGreaterThan !== null) {
            queryParameters = queryParameters.set('datains.greaterThan', <any>datainsGreaterThan.toISOString());
        }
        if (datainsGreaterThanOrEqual !== undefined && datainsGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('datains.greaterThanOrEqual', <any>datainsGreaterThanOrEqual.toISOString());
        }
        if (datainsIn0DayOfMonth !== undefined && datainsIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfMonth', <any>datainsIn0DayOfMonth);
        }
        if (datainsIn0DayOfWeek !== undefined && datainsIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfWeek', <any>datainsIn0DayOfWeek);
        }
        if (datainsIn0DayOfYear !== undefined && datainsIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfYear', <any>datainsIn0DayOfYear);
        }
        if (datainsIn0Hour !== undefined && datainsIn0Hour !== null) {
            queryParameters = queryParameters.set('datains.in[0].hour', <any>datainsIn0Hour);
        }
        if (datainsIn0Minute !== undefined && datainsIn0Minute !== null) {
            queryParameters = queryParameters.set('datains.in[0].minute', <any>datainsIn0Minute);
        }
        if (datainsIn0Month !== undefined && datainsIn0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].month', <any>datainsIn0Month);
        }
        if (datainsIn0MonthValue !== undefined && datainsIn0MonthValue !== null) {
            queryParameters = queryParameters.set('datains.in[0].monthValue', <any>datainsIn0MonthValue);
        }
        if (datainsIn0Nano !== undefined && datainsIn0Nano !== null) {
            queryParameters = queryParameters.set('datains.in[0].nano', <any>datainsIn0Nano);
        }
        if (datainsIn0OffsetId !== undefined && datainsIn0OffsetId !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.id', <any>datainsIn0OffsetId);
        }
        if (datainsIn0OffsetRulesFixedOffset !== undefined && datainsIn0OffsetRulesFixedOffset !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.fixedOffset', <any>datainsIn0OffsetRulesFixedOffset);
        }
        if (datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator !== undefined && datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].dayOfMonthIndicator', <any>datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator);
        }
        if (datainsIn0OffsetRulesTransitionRules0DayOfWeek !== undefined && datainsIn0OffsetRulesTransitionRules0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].dayOfWeek', <any>datainsIn0OffsetRulesTransitionRules0DayOfWeek);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeHour !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeHour !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.hour', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeHour);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeMinute !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeMinute !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.minute', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeMinute);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeNano !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.nano', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeNano);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeSecond !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeSecond !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.second', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeSecond);
        }
        if (datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay !== undefined && datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].midnightEndOfDay', <any>datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay);
        }
        if (datainsIn0OffsetRulesTransitionRules0Month !== undefined && datainsIn0OffsetRulesTransitionRules0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].month', <any>datainsIn0OffsetRulesTransitionRules0Month);
        }
        if (datainsIn0OffsetRulesTransitionRules0TimeDefinition !== undefined && datainsIn0OffsetRulesTransitionRules0TimeDefinition !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].timeDefinition', <any>datainsIn0OffsetRulesTransitionRules0TimeDefinition);
        }
        if (datainsIn0OffsetRulesTransitions0DateTimeAfter !== undefined && datainsIn0OffsetRulesTransitions0DateTimeAfter !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].dateTimeAfter', <any>datainsIn0OffsetRulesTransitions0DateTimeAfter.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0DateTimeBefore !== undefined && datainsIn0OffsetRulesTransitions0DateTimeBefore !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].dateTimeBefore', <any>datainsIn0OffsetRulesTransitions0DateTimeBefore.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0DurationNano !== undefined && datainsIn0OffsetRulesTransitions0DurationNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.nano', <any>datainsIn0OffsetRulesTransitions0DurationNano);
        }
        if (datainsIn0OffsetRulesTransitions0DurationNegative !== undefined && datainsIn0OffsetRulesTransitions0DurationNegative !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.negative', <any>datainsIn0OffsetRulesTransitions0DurationNegative);
        }
        if (datainsIn0OffsetRulesTransitions0DurationSeconds !== undefined && datainsIn0OffsetRulesTransitions0DurationSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.seconds', <any>datainsIn0OffsetRulesTransitions0DurationSeconds);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0DateBased !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0DateBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].dateBased', <any>datainsIn0OffsetRulesTransitions0DurationUnits0DateBased);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].durationEstimated', <any>datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].timeBased', <any>datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased);
        }
        if (datainsIn0OffsetRulesTransitions0DurationZero !== undefined && datainsIn0OffsetRulesTransitions0DurationZero !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.zero', <any>datainsIn0OffsetRulesTransitions0DurationZero);
        }
        if (datainsIn0OffsetRulesTransitions0Gap !== undefined && datainsIn0OffsetRulesTransitions0Gap !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].gap', <any>datainsIn0OffsetRulesTransitions0Gap);
        }
        if (datainsIn0OffsetRulesTransitions0Instant !== undefined && datainsIn0OffsetRulesTransitions0Instant !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].instant', <any>datainsIn0OffsetRulesTransitions0Instant.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0Overlap !== undefined && datainsIn0OffsetRulesTransitions0Overlap !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].overlap', <any>datainsIn0OffsetRulesTransitions0Overlap);
        }
        if (datainsIn0OffsetTotalSeconds !== undefined && datainsIn0OffsetTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.totalSeconds', <any>datainsIn0OffsetTotalSeconds);
        }
        if (datainsIn0Second !== undefined && datainsIn0Second !== null) {
            queryParameters = queryParameters.set('datains.in[0].second', <any>datainsIn0Second);
        }
        if (datainsIn0Year !== undefined && datainsIn0Year !== null) {
            queryParameters = queryParameters.set('datains.in[0].year', <any>datainsIn0Year);
        }
        if (datainsIn0ZoneId !== undefined && datainsIn0ZoneId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.id', <any>datainsIn0ZoneId);
        }
        if (datainsIn0ZoneRulesFixedOffset !== undefined && datainsIn0ZoneRulesFixedOffset !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.fixedOffset', <any>datainsIn0ZoneRulesFixedOffset);
        }
        if (datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator !== undefined && datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].dayOfMonthIndicator', <any>datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator);
        }
        if (datainsIn0ZoneRulesTransitionRules0DayOfWeek !== undefined && datainsIn0ZoneRulesTransitionRules0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].dayOfWeek', <any>datainsIn0ZoneRulesTransitionRules0DayOfWeek);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeHour !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeHour !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.hour', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeHour);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeMinute !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeMinute !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.minute', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeMinute);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeNano !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.nano', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeNano);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeSecond !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeSecond !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.second', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeSecond);
        }
        if (datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay !== undefined && datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].midnightEndOfDay', <any>datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay);
        }
        if (datainsIn0ZoneRulesTransitionRules0Month !== undefined && datainsIn0ZoneRulesTransitionRules0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].month', <any>datainsIn0ZoneRulesTransitionRules0Month);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetAfterId !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetAfterId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetAfter.id', <any>datainsIn0ZoneRulesTransitionRules0OffsetAfterId);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetAfter.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetBeforeId !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetBeforeId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetBefore.id', <any>datainsIn0ZoneRulesTransitionRules0OffsetBeforeId);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetBefore.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0StandardOffsetId !== undefined && datainsIn0ZoneRulesTransitionRules0StandardOffsetId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].standardOffset.id', <any>datainsIn0ZoneRulesTransitionRules0StandardOffsetId);
        }
        if (datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].standardOffset.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0TimeDefinition !== undefined && datainsIn0ZoneRulesTransitionRules0TimeDefinition !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].timeDefinition', <any>datainsIn0ZoneRulesTransitionRules0TimeDefinition);
        }
        if (datainsIn0ZoneRulesTransitions0DateTimeAfter !== undefined && datainsIn0ZoneRulesTransitions0DateTimeAfter !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].dateTimeAfter', <any>datainsIn0ZoneRulesTransitions0DateTimeAfter.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0DateTimeBefore !== undefined && datainsIn0ZoneRulesTransitions0DateTimeBefore !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].dateTimeBefore', <any>datainsIn0ZoneRulesTransitions0DateTimeBefore.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0DurationNano !== undefined && datainsIn0ZoneRulesTransitions0DurationNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.nano', <any>datainsIn0ZoneRulesTransitions0DurationNano);
        }
        if (datainsIn0ZoneRulesTransitions0DurationNegative !== undefined && datainsIn0ZoneRulesTransitions0DurationNegative !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.negative', <any>datainsIn0ZoneRulesTransitions0DurationNegative);
        }
        if (datainsIn0ZoneRulesTransitions0DurationSeconds !== undefined && datainsIn0ZoneRulesTransitions0DurationSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.seconds', <any>datainsIn0ZoneRulesTransitions0DurationSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0DateBased !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0DateBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].dateBased', <any>datainsIn0ZoneRulesTransitions0DurationUnits0DateBased);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].durationEstimated', <any>datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].timeBased', <any>datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased);
        }
        if (datainsIn0ZoneRulesTransitions0DurationZero !== undefined && datainsIn0ZoneRulesTransitions0DurationZero !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.zero', <any>datainsIn0ZoneRulesTransitions0DurationZero);
        }
        if (datainsIn0ZoneRulesTransitions0Gap !== undefined && datainsIn0ZoneRulesTransitions0Gap !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].gap', <any>datainsIn0ZoneRulesTransitions0Gap);
        }
        if (datainsIn0ZoneRulesTransitions0Instant !== undefined && datainsIn0ZoneRulesTransitions0Instant !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].instant', <any>datainsIn0ZoneRulesTransitions0Instant.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0OffsetAfterId !== undefined && datainsIn0ZoneRulesTransitions0OffsetAfterId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetAfter.id', <any>datainsIn0ZoneRulesTransitions0OffsetAfterId);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds !== undefined && datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetAfter.totalSeconds', <any>datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetBeforeId !== undefined && datainsIn0ZoneRulesTransitions0OffsetBeforeId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetBefore.id', <any>datainsIn0ZoneRulesTransitions0OffsetBeforeId);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds !== undefined && datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetBefore.totalSeconds', <any>datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0Overlap !== undefined && datainsIn0ZoneRulesTransitions0Overlap !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].overlap', <any>datainsIn0ZoneRulesTransitions0Overlap);
        }
        if (datainsLessThan !== undefined && datainsLessThan !== null) {
            queryParameters = queryParameters.set('datains.lessThan', <any>datainsLessThan.toISOString());
        }
        if (datainsLessThanOrEqual !== undefined && datainsLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('datains.lessThanOrEqual', <any>datainsLessThanOrEqual.toISOString());
        }
        if (datainsNotEquals !== undefined && datainsNotEquals !== null) {
            queryParameters = queryParameters.set('datains.notEquals', <any>datainsNotEquals.toISOString());
        }
        if (datainsSpecified !== undefined && datainsSpecified !== null) {
            queryParameters = queryParameters.set('datains.specified', <any>datainsSpecified);
        }
        if (dataregistrazioneEquals !== undefined && dataregistrazioneEquals !== null) {
            queryParameters = queryParameters.set('dataregistrazione.equals', <any>dataregistrazioneEquals);
        }
        if (dataregistrazioneGreaterThan !== undefined && dataregistrazioneGreaterThan !== null) {
            queryParameters = queryParameters.set('dataregistrazione.greaterThan', <any>dataregistrazioneGreaterThan);
        }
        if (dataregistrazioneGreaterThanOrEqual !== undefined && dataregistrazioneGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('dataregistrazione.greaterThanOrEqual', <any>dataregistrazioneGreaterThanOrEqual);
        }
        if (dataregistrazioneIn0ChronologyCalendarType !== undefined && dataregistrazioneIn0ChronologyCalendarType !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].chronology.calendarType', <any>dataregistrazioneIn0ChronologyCalendarType);
        }
        if (dataregistrazioneIn0ChronologyId !== undefined && dataregistrazioneIn0ChronologyId !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].chronology.id', <any>dataregistrazioneIn0ChronologyId);
        }
        if (dataregistrazioneIn0DayOfMonth !== undefined && dataregistrazioneIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfMonth', <any>dataregistrazioneIn0DayOfMonth);
        }
        if (dataregistrazioneIn0DayOfWeek !== undefined && dataregistrazioneIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfWeek', <any>dataregistrazioneIn0DayOfWeek);
        }
        if (dataregistrazioneIn0DayOfYear !== undefined && dataregistrazioneIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfYear', <any>dataregistrazioneIn0DayOfYear);
        }
        if (dataregistrazioneIn0EraValue !== undefined && dataregistrazioneIn0EraValue !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].era.value', <any>dataregistrazioneIn0EraValue);
        }
        if (dataregistrazioneIn0LeapYear !== undefined && dataregistrazioneIn0LeapYear !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].leapYear', <any>dataregistrazioneIn0LeapYear);
        }
        if (dataregistrazioneIn0Month !== undefined && dataregistrazioneIn0Month !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].month', <any>dataregistrazioneIn0Month);
        }
        if (dataregistrazioneIn0MonthValue !== undefined && dataregistrazioneIn0MonthValue !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].monthValue', <any>dataregistrazioneIn0MonthValue);
        }
        if (dataregistrazioneIn0Year !== undefined && dataregistrazioneIn0Year !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].year', <any>dataregistrazioneIn0Year);
        }
        if (dataregistrazioneLessThan !== undefined && dataregistrazioneLessThan !== null) {
            queryParameters = queryParameters.set('dataregistrazione.lessThan', <any>dataregistrazioneLessThan);
        }
        if (dataregistrazioneLessThanOrEqual !== undefined && dataregistrazioneLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('dataregistrazione.lessThanOrEqual', <any>dataregistrazioneLessThanOrEqual);
        }
        if (dataregistrazioneNotEquals !== undefined && dataregistrazioneNotEquals !== null) {
            queryParameters = queryParameters.set('dataregistrazione.notEquals', <any>dataregistrazioneNotEquals);
        }
        if (dataregistrazioneSpecified !== undefined && dataregistrazioneSpecified !== null) {
            queryParameters = queryParameters.set('dataregistrazione.specified', <any>dataregistrazioneSpecified);
        }
        if (fornitoreEquals !== undefined && fornitoreEquals !== null) {
            queryParameters = queryParameters.set('fornitore.equals', <any>fornitoreEquals);
        }
        if (fornitoreIn) {
            fornitoreIn.forEach((element) => {
                queryParameters = queryParameters.append('fornitore.in', <any>element);
            })
        }
        if (fornitoreNotEquals !== undefined && fornitoreNotEquals !== null) {
            queryParameters = queryParameters.set('fornitore.notEquals', <any>fornitoreNotEquals);
        }
        if (fornitoreSpecified !== undefined && fornitoreSpecified !== null) {
            queryParameters = queryParameters.set('fornitore.specified', <any>fornitoreSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (idanagraficaEquals !== undefined && idanagraficaEquals !== null) {
            queryParameters = queryParameters.set('idanagrafica.equals', <any>idanagraficaEquals);
        }
        if (idanagraficaGreaterThan !== undefined && idanagraficaGreaterThan !== null) {
            queryParameters = queryParameters.set('idanagrafica.greaterThan', <any>idanagraficaGreaterThan);
        }
        if (idanagraficaGreaterThanOrEqual !== undefined && idanagraficaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idanagrafica.greaterThanOrEqual', <any>idanagraficaGreaterThanOrEqual);
        }
        if (idanagraficaIn) {
            idanagraficaIn.forEach((element) => {
                queryParameters = queryParameters.append('idanagrafica.in', <any>element);
            })
        }
        if (idanagraficaLessThan !== undefined && idanagraficaLessThan !== null) {
            queryParameters = queryParameters.set('idanagrafica.lessThan', <any>idanagraficaLessThan);
        }
        if (idanagraficaLessThanOrEqual !== undefined && idanagraficaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idanagrafica.lessThanOrEqual', <any>idanagraficaLessThanOrEqual);
        }
        if (idanagraficaNotEquals !== undefined && idanagraficaNotEquals !== null) {
            queryParameters = queryParameters.set('idanagrafica.notEquals', <any>idanagraficaNotEquals);
        }
        if (idanagraficaSpecified !== undefined && idanagraficaSpecified !== null) {
            queryParameters = queryParameters.set('idanagrafica.specified', <any>idanagraficaSpecified);
        }
        if (idaziendaEquals !== undefined && idaziendaEquals !== null) {
            queryParameters = queryParameters.set('idazienda.equals', <any>idaziendaEquals);
        }
        if (idaziendaGreaterThan !== undefined && idaziendaGreaterThan !== null) {
            queryParameters = queryParameters.set('idazienda.greaterThan', <any>idaziendaGreaterThan);
        }
        if (idaziendaGreaterThanOrEqual !== undefined && idaziendaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idazienda.greaterThanOrEqual', <any>idaziendaGreaterThanOrEqual);
        }
        if (idaziendaIn) {
            idaziendaIn.forEach((element) => {
                queryParameters = queryParameters.append('idazienda.in', <any>element);
            })
        }
        if (idaziendaLessThan !== undefined && idaziendaLessThan !== null) {
            queryParameters = queryParameters.set('idazienda.lessThan', <any>idaziendaLessThan);
        }
        if (idaziendaLessThanOrEqual !== undefined && idaziendaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idazienda.lessThanOrEqual', <any>idaziendaLessThanOrEqual);
        }
        if (idaziendaNotEquals !== undefined && idaziendaNotEquals !== null) {
            queryParameters = queryParameters.set('idazienda.notEquals', <any>idaziendaNotEquals);
        }
        if (idaziendaSpecified !== undefined && idaziendaSpecified !== null) {
            queryParameters = queryParameters.set('idazienda.specified', <any>idaziendaSpecified);
        }
        if (iddocumentoContains !== undefined && iddocumentoContains !== null) {
            queryParameters = queryParameters.set('iddocumento.contains', <any>iddocumentoContains);
        }
        if (iddocumentoDoesNotContain !== undefined && iddocumentoDoesNotContain !== null) {
            queryParameters = queryParameters.set('iddocumento.doesNotContain', <any>iddocumentoDoesNotContain);
        }
        if (iddocumentoEquals !== undefined && iddocumentoEquals !== null) {
            queryParameters = queryParameters.set('iddocumento.equals', <any>iddocumentoEquals);
        }
        if (iddocumentoIn) {
            iddocumentoIn.forEach((element) => {
                queryParameters = queryParameters.append('iddocumento.in', <any>element);
            })
        }
        if (iddocumentoNotEquals !== undefined && iddocumentoNotEquals !== null) {
            queryParameters = queryParameters.set('iddocumento.notEquals', <any>iddocumentoNotEquals);
        }
        if (iddocumentoSpecified !== undefined && iddocumentoSpecified !== null) {
            queryParameters = queryParameters.set('iddocumento.specified', <any>iddocumentoSpecified);
        }
        if (idsottocontoContains !== undefined && idsottocontoContains !== null) {
            queryParameters = queryParameters.set('idsottoconto.contains', <any>idsottocontoContains);
        }
        if (idsottocontoDoesNotContain !== undefined && idsottocontoDoesNotContain !== null) {
            queryParameters = queryParameters.set('idsottoconto.doesNotContain', <any>idsottocontoDoesNotContain);
        }
        if (idsottocontoEquals !== undefined && idsottocontoEquals !== null) {
            queryParameters = queryParameters.set('idsottoconto.equals', <any>idsottocontoEquals);
        }
        if (idsottocontoIn) {
            idsottocontoIn.forEach((element) => {
                queryParameters = queryParameters.append('idsottoconto.in', <any>element);
            })
        }
        if (idsottocontoNotEquals !== undefined && idsottocontoNotEquals !== null) {
            queryParameters = queryParameters.set('idsottoconto.notEquals', <any>idsottocontoNotEquals);
        }
        if (idsottocontoSpecified !== undefined && idsottocontoSpecified !== null) {
            queryParameters = queryParameters.set('idsottoconto.specified', <any>idsottocontoSpecified);
        }
        if (indirizzoContains !== undefined && indirizzoContains !== null) {
            queryParameters = queryParameters.set('indirizzo.contains', <any>indirizzoContains);
        }
        if (indirizzoDoesNotContain !== undefined && indirizzoDoesNotContain !== null) {
            queryParameters = queryParameters.set('indirizzo.doesNotContain', <any>indirizzoDoesNotContain);
        }
        if (indirizzoEquals !== undefined && indirizzoEquals !== null) {
            queryParameters = queryParameters.set('indirizzo.equals', <any>indirizzoEquals);
        }
        if (indirizzoIn) {
            indirizzoIn.forEach((element) => {
                queryParameters = queryParameters.append('indirizzo.in', <any>element);
            })
        }
        if (indirizzoNotEquals !== undefined && indirizzoNotEquals !== null) {
            queryParameters = queryParameters.set('indirizzo.notEquals', <any>indirizzoNotEquals);
        }
        if (indirizzoSpecified !== undefined && indirizzoSpecified !== null) {
            queryParameters = queryParameters.set('indirizzo.specified', <any>indirizzoSpecified);
        }
        if (intestazioneContains !== undefined && intestazioneContains !== null) {
            queryParameters = queryParameters.set('intestazione.contains', <any>intestazioneContains);
        }
        if (intestazioneDoesNotContain !== undefined && intestazioneDoesNotContain !== null) {
            queryParameters = queryParameters.set('intestazione.doesNotContain', <any>intestazioneDoesNotContain);
        }
        if (intestazioneEquals !== undefined && intestazioneEquals !== null) {
            queryParameters = queryParameters.set('intestazione.equals', <any>intestazioneEquals);
        }
        if (intestazioneIn) {
            intestazioneIn.forEach((element) => {
                queryParameters = queryParameters.append('intestazione.in', <any>element);
            })
        }
        if (intestazioneNotEquals !== undefined && intestazioneNotEquals !== null) {
            queryParameters = queryParameters.set('intestazione.notEquals', <any>intestazioneNotEquals);
        }
        if (intestazioneSpecified !== undefined && intestazioneSpecified !== null) {
            queryParameters = queryParameters.set('intestazione.specified', <any>intestazioneSpecified);
        }
        if (ivaEquals !== undefined && ivaEquals !== null) {
            queryParameters = queryParameters.set('iva.equals', <any>ivaEquals);
        }
        if (ivaGreaterThan !== undefined && ivaGreaterThan !== null) {
            queryParameters = queryParameters.set('iva.greaterThan', <any>ivaGreaterThan);
        }
        if (ivaGreaterThanOrEqual !== undefined && ivaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.greaterThanOrEqual', <any>ivaGreaterThanOrEqual);
        }
        if (ivaIn) {
            ivaIn.forEach((element) => {
                queryParameters = queryParameters.append('iva.in', <any>element);
            })
        }
        if (ivaLessThan !== undefined && ivaLessThan !== null) {
            queryParameters = queryParameters.set('iva.lessThan', <any>ivaLessThan);
        }
        if (ivaLessThanOrEqual !== undefined && ivaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.lessThanOrEqual', <any>ivaLessThanOrEqual);
        }
        if (ivaNotEquals !== undefined && ivaNotEquals !== null) {
            queryParameters = queryParameters.set('iva.notEquals', <any>ivaNotEquals);
        }
        if (ivaSpecified !== undefined && ivaSpecified !== null) {
            queryParameters = queryParameters.set('iva.specified', <any>ivaSpecified);
        }
        if (ivasinoEquals !== undefined && ivasinoEquals !== null) {
            queryParameters = queryParameters.set('ivasino.equals', <any>ivasinoEquals);
        }
        if (ivasinoIn) {
            ivasinoIn.forEach((element) => {
                queryParameters = queryParameters.append('ivasino.in', <any>element);
            })
        }
        if (ivasinoNotEquals !== undefined && ivasinoNotEquals !== null) {
            queryParameters = queryParameters.set('ivasino.notEquals', <any>ivasinoNotEquals);
        }
        if (ivasinoSpecified !== undefined && ivasinoSpecified !== null) {
            queryParameters = queryParameters.set('ivasino.specified', <any>ivasinoSpecified);
        }
        if (mdopagEquals !== undefined && mdopagEquals !== null) {
            queryParameters = queryParameters.set('mdopag.equals', <any>mdopagEquals);
        }
        if (mdopagGreaterThan !== undefined && mdopagGreaterThan !== null) {
            queryParameters = queryParameters.set('mdopag.greaterThan', <any>mdopagGreaterThan);
        }
        if (mdopagGreaterThanOrEqual !== undefined && mdopagGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('mdopag.greaterThanOrEqual', <any>mdopagGreaterThanOrEqual);
        }
        if (mdopagIn) {
            mdopagIn.forEach((element) => {
                queryParameters = queryParameters.append('mdopag.in', <any>element);
            })
        }
        if (mdopagLessThan !== undefined && mdopagLessThan !== null) {
            queryParameters = queryParameters.set('mdopag.lessThan', <any>mdopagLessThan);
        }
        if (mdopagLessThanOrEqual !== undefined && mdopagLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('mdopag.lessThanOrEqual', <any>mdopagLessThanOrEqual);
        }
        if (mdopagNotEquals !== undefined && mdopagNotEquals !== null) {
            queryParameters = queryParameters.set('mdopag.notEquals', <any>mdopagNotEquals);
        }
        if (mdopagSpecified !== undefined && mdopagSpecified !== null) {
            queryParameters = queryParameters.set('mdopag.specified', <any>mdopagSpecified);
        }
        if (ndocContains !== undefined && ndocContains !== null) {
            queryParameters = queryParameters.set('ndoc.contains', <any>ndocContains);
        }
        if (ndocDoesNotContain !== undefined && ndocDoesNotContain !== null) {
            queryParameters = queryParameters.set('ndoc.doesNotContain', <any>ndocDoesNotContain);
        }
        if (ndocEquals !== undefined && ndocEquals !== null) {
            queryParameters = queryParameters.set('ndoc.equals', <any>ndocEquals);
        }
        if (ndocIn) {
            ndocIn.forEach((element) => {
                queryParameters = queryParameters.append('ndoc.in', <any>element);
            })
        }
        if (ndocNotEquals !== undefined && ndocNotEquals !== null) {
            queryParameters = queryParameters.set('ndoc.notEquals', <any>ndocNotEquals);
        }
        if (ndocSpecified !== undefined && ndocSpecified !== null) {
            queryParameters = queryParameters.set('ndoc.specified', <any>ndocSpecified);
        }
        if (ndocSuffEquals !== undefined && ndocSuffEquals !== null) {
            queryParameters = queryParameters.set('ndocSuff.equals', <any>ndocSuffEquals);
        }
        if (ndocSuffGreaterThan !== undefined && ndocSuffGreaterThan !== null) {
            queryParameters = queryParameters.set('ndocSuff.greaterThan', <any>ndocSuffGreaterThan);
        }
        if (ndocSuffGreaterThanOrEqual !== undefined && ndocSuffGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('ndocSuff.greaterThanOrEqual', <any>ndocSuffGreaterThanOrEqual);
        }
        if (ndocSuffIn) {
            ndocSuffIn.forEach((element) => {
                queryParameters = queryParameters.append('ndocSuff.in', <any>element);
            })
        }
        if (ndocSuffLessThan !== undefined && ndocSuffLessThan !== null) {
            queryParameters = queryParameters.set('ndocSuff.lessThan', <any>ndocSuffLessThan);
        }
        if (ndocSuffLessThanOrEqual !== undefined && ndocSuffLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('ndocSuff.lessThanOrEqual', <any>ndocSuffLessThanOrEqual);
        }
        if (ndocSuffNotEquals !== undefined && ndocSuffNotEquals !== null) {
            queryParameters = queryParameters.set('ndocSuff.notEquals', <any>ndocSuffNotEquals);
        }
        if (ndocSuffSpecified !== undefined && ndocSuffSpecified !== null) {
            queryParameters = queryParameters.set('ndocSuff.specified', <any>ndocSuffSpecified);
        }
        if (noteContains !== undefined && noteContains !== null) {
            queryParameters = queryParameters.set('note.contains', <any>noteContains);
        }
        if (noteDoesNotContain !== undefined && noteDoesNotContain !== null) {
            queryParameters = queryParameters.set('note.doesNotContain', <any>noteDoesNotContain);
        }
        if (noteEquals !== undefined && noteEquals !== null) {
            queryParameters = queryParameters.set('note.equals', <any>noteEquals);
        }
        if (noteIn) {
            noteIn.forEach((element) => {
                queryParameters = queryParameters.append('note.in', <any>element);
            })
        }
        if (noteNotEquals !== undefined && noteNotEquals !== null) {
            queryParameters = queryParameters.set('note.notEquals', <any>noteNotEquals);
        }
        if (noteSpecified !== undefined && noteSpecified !== null) {
            queryParameters = queryParameters.set('note.specified', <any>noteSpecified);
        }
        if (opeinsContains !== undefined && opeinsContains !== null) {
            queryParameters = queryParameters.set('opeins.contains', <any>opeinsContains);
        }
        if (opeinsDoesNotContain !== undefined && opeinsDoesNotContain !== null) {
            queryParameters = queryParameters.set('opeins.doesNotContain', <any>opeinsDoesNotContain);
        }
        if (opeinsEquals !== undefined && opeinsEquals !== null) {
            queryParameters = queryParameters.set('opeins.equals', <any>opeinsEquals);
        }
        if (opeinsIn) {
            opeinsIn.forEach((element) => {
                queryParameters = queryParameters.append('opeins.in', <any>element);
            })
        }
        if (opeinsNotEquals !== undefined && opeinsNotEquals !== null) {
            queryParameters = queryParameters.set('opeins.notEquals', <any>opeinsNotEquals);
        }
        if (opeinsSpecified !== undefined && opeinsSpecified !== null) {
            queryParameters = queryParameters.set('opeins.specified', <any>opeinsSpecified);
        }
        if (pecContains !== undefined && pecContains !== null) {
            queryParameters = queryParameters.set('pec.contains', <any>pecContains);
        }
        if (pecDoesNotContain !== undefined && pecDoesNotContain !== null) {
            queryParameters = queryParameters.set('pec.doesNotContain', <any>pecDoesNotContain);
        }
        if (pecEquals !== undefined && pecEquals !== null) {
            queryParameters = queryParameters.set('pec.equals', <any>pecEquals);
        }
        if (pecIn) {
            pecIn.forEach((element) => {
                queryParameters = queryParameters.append('pec.in', <any>element);
            })
        }
        if (pecNotEquals !== undefined && pecNotEquals !== null) {
            queryParameters = queryParameters.set('pec.notEquals', <any>pecNotEquals);
        }
        if (pecSpecified !== undefined && pecSpecified !== null) {
            queryParameters = queryParameters.set('pec.specified', <any>pecSpecified);
        }
        if (percentIvaEquals !== undefined && percentIvaEquals !== null) {
            queryParameters = queryParameters.set('percentIva.equals', <any>percentIvaEquals);
        }
        if (percentIvaGreaterThan !== undefined && percentIvaGreaterThan !== null) {
            queryParameters = queryParameters.set('percentIva.greaterThan', <any>percentIvaGreaterThan);
        }
        if (percentIvaGreaterThanOrEqual !== undefined && percentIvaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('percentIva.greaterThanOrEqual', <any>percentIvaGreaterThanOrEqual);
        }
        if (percentIvaIn) {
            percentIvaIn.forEach((element) => {
                queryParameters = queryParameters.append('percentIva.in', <any>element);
            })
        }
        if (percentIvaLessThan !== undefined && percentIvaLessThan !== null) {
            queryParameters = queryParameters.set('percentIva.lessThan', <any>percentIvaLessThan);
        }
        if (percentIvaLessThanOrEqual !== undefined && percentIvaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('percentIva.lessThanOrEqual', <any>percentIvaLessThanOrEqual);
        }
        if (percentIvaNotEquals !== undefined && percentIvaNotEquals !== null) {
            queryParameters = queryParameters.set('percentIva.notEquals', <any>percentIvaNotEquals);
        }
        if (percentIvaSpecified !== undefined && percentIvaSpecified !== null) {
            queryParameters = queryParameters.set('percentIva.specified', <any>percentIvaSpecified);
        }
        if (percritenutaEquals !== undefined && percritenutaEquals !== null) {
            queryParameters = queryParameters.set('percritenuta.equals', <any>percritenutaEquals);
        }
        if (percritenutaGreaterThan !== undefined && percritenutaGreaterThan !== null) {
            queryParameters = queryParameters.set('percritenuta.greaterThan', <any>percritenutaGreaterThan);
        }
        if (percritenutaGreaterThanOrEqual !== undefined && percritenutaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('percritenuta.greaterThanOrEqual', <any>percritenutaGreaterThanOrEqual);
        }
        if (percritenutaIn) {
            percritenutaIn.forEach((element) => {
                queryParameters = queryParameters.append('percritenuta.in', <any>element);
            })
        }
        if (percritenutaLessThan !== undefined && percritenutaLessThan !== null) {
            queryParameters = queryParameters.set('percritenuta.lessThan', <any>percritenutaLessThan);
        }
        if (percritenutaLessThanOrEqual !== undefined && percritenutaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('percritenuta.lessThanOrEqual', <any>percritenutaLessThanOrEqual);
        }
        if (percritenutaNotEquals !== undefined && percritenutaNotEquals !== null) {
            queryParameters = queryParameters.set('percritenuta.notEquals', <any>percritenutaNotEquals);
        }
        if (percritenutaSpecified !== undefined && percritenutaSpecified !== null) {
            queryParameters = queryParameters.set('percritenuta.specified', <any>percritenutaSpecified);
        }
        if (pivaContains !== undefined && pivaContains !== null) {
            queryParameters = queryParameters.set('piva.contains', <any>pivaContains);
        }
        if (pivaDoesNotContain !== undefined && pivaDoesNotContain !== null) {
            queryParameters = queryParameters.set('piva.doesNotContain', <any>pivaDoesNotContain);
        }
        if (pivaEquals !== undefined && pivaEquals !== null) {
            queryParameters = queryParameters.set('piva.equals', <any>pivaEquals);
        }
        if (pivaIn) {
            pivaIn.forEach((element) => {
                queryParameters = queryParameters.append('piva.in', <any>element);
            })
        }
        if (pivaNotEquals !== undefined && pivaNotEquals !== null) {
            queryParameters = queryParameters.set('piva.notEquals', <any>pivaNotEquals);
        }
        if (pivaSpecified !== undefined && pivaSpecified !== null) {
            queryParameters = queryParameters.set('piva.specified', <any>pivaSpecified);
        }
        if (protSuffEquals !== undefined && protSuffEquals !== null) {
            queryParameters = queryParameters.set('protSuff.equals', <any>protSuffEquals);
        }
        if (protSuffGreaterThan !== undefined && protSuffGreaterThan !== null) {
            queryParameters = queryParameters.set('protSuff.greaterThan', <any>protSuffGreaterThan);
        }
        if (protSuffGreaterThanOrEqual !== undefined && protSuffGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('protSuff.greaterThanOrEqual', <any>protSuffGreaterThanOrEqual);
        }
        if (protSuffIn) {
            protSuffIn.forEach((element) => {
                queryParameters = queryParameters.append('protSuff.in', <any>element);
            })
        }
        if (protSuffLessThan !== undefined && protSuffLessThan !== null) {
            queryParameters = queryParameters.set('protSuff.lessThan', <any>protSuffLessThan);
        }
        if (protSuffLessThanOrEqual !== undefined && protSuffLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('protSuff.lessThanOrEqual', <any>protSuffLessThanOrEqual);
        }
        if (protSuffNotEquals !== undefined && protSuffNotEquals !== null) {
            queryParameters = queryParameters.set('protSuff.notEquals', <any>protSuffNotEquals);
        }
        if (protSuffSpecified !== undefined && protSuffSpecified !== null) {
            queryParameters = queryParameters.set('protSuff.specified', <any>protSuffSpecified);
        }
        if (protocolloEquals !== undefined && protocolloEquals !== null) {
            queryParameters = queryParameters.set('protocollo.equals', <any>protocolloEquals);
        }
        if (protocolloGreaterThan !== undefined && protocolloGreaterThan !== null) {
            queryParameters = queryParameters.set('protocollo.greaterThan', <any>protocolloGreaterThan);
        }
        if (protocolloGreaterThanOrEqual !== undefined && protocolloGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('protocollo.greaterThanOrEqual', <any>protocolloGreaterThanOrEqual);
        }
        if (protocolloIn) {
            protocolloIn.forEach((element) => {
                queryParameters = queryParameters.append('protocollo.in', <any>element);
            })
        }
        if (protocolloLessThan !== undefined && protocolloLessThan !== null) {
            queryParameters = queryParameters.set('protocollo.lessThan', <any>protocolloLessThan);
        }
        if (protocolloLessThanOrEqual !== undefined && protocolloLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('protocollo.lessThanOrEqual', <any>protocolloLessThanOrEqual);
        }
        if (protocolloNotEquals !== undefined && protocolloNotEquals !== null) {
            queryParameters = queryParameters.set('protocollo.notEquals', <any>protocolloNotEquals);
        }
        if (protocolloSpecified !== undefined && protocolloSpecified !== null) {
            queryParameters = queryParameters.set('protocollo.specified', <any>protocolloSpecified);
        }
        if (provContains !== undefined && provContains !== null) {
            queryParameters = queryParameters.set('prov.contains', <any>provContains);
        }
        if (provDoesNotContain !== undefined && provDoesNotContain !== null) {
            queryParameters = queryParameters.set('prov.doesNotContain', <any>provDoesNotContain);
        }
        if (provEquals !== undefined && provEquals !== null) {
            queryParameters = queryParameters.set('prov.equals', <any>provEquals);
        }
        if (provIn) {
            provIn.forEach((element) => {
                queryParameters = queryParameters.append('prov.in', <any>element);
            })
        }
        if (provNotEquals !== undefined && provNotEquals !== null) {
            queryParameters = queryParameters.set('prov.notEquals', <any>provNotEquals);
        }
        if (provSpecified !== undefined && provSpecified !== null) {
            queryParameters = queryParameters.set('prov.specified', <any>provSpecified);
        }
        if (ritenutaEquals !== undefined && ritenutaEquals !== null) {
            queryParameters = queryParameters.set('ritenuta.equals', <any>ritenutaEquals);
        }
        if (ritenutaGreaterThan !== undefined && ritenutaGreaterThan !== null) {
            queryParameters = queryParameters.set('ritenuta.greaterThan', <any>ritenutaGreaterThan);
        }
        if (ritenutaGreaterThanOrEqual !== undefined && ritenutaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('ritenuta.greaterThanOrEqual', <any>ritenutaGreaterThanOrEqual);
        }
        if (ritenutaIn) {
            ritenutaIn.forEach((element) => {
                queryParameters = queryParameters.append('ritenuta.in', <any>element);
            })
        }
        if (ritenutaLessThan !== undefined && ritenutaLessThan !== null) {
            queryParameters = queryParameters.set('ritenuta.lessThan', <any>ritenutaLessThan);
        }
        if (ritenutaLessThanOrEqual !== undefined && ritenutaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('ritenuta.lessThanOrEqual', <any>ritenutaLessThanOrEqual);
        }
        if (ritenutaNotEquals !== undefined && ritenutaNotEquals !== null) {
            queryParameters = queryParameters.set('ritenuta.notEquals', <any>ritenutaNotEquals);
        }
        if (ritenutaSpecified !== undefined && ritenutaSpecified !== null) {
            queryParameters = queryParameters.set('ritenuta.specified', <any>ritenutaSpecified);
        }
        if (tipoContains !== undefined && tipoContains !== null) {
            queryParameters = queryParameters.set('tipo.contains', <any>tipoContains);
        }
        if (tipoDoesNotContain !== undefined && tipoDoesNotContain !== null) {
            queryParameters = queryParameters.set('tipo.doesNotContain', <any>tipoDoesNotContain);
        }
        if (tipoEquals !== undefined && tipoEquals !== null) {
            queryParameters = queryParameters.set('tipo.equals', <any>tipoEquals);
        }
        if (tipoIn) {
            tipoIn.forEach((element) => {
                queryParameters = queryParameters.append('tipo.in', <any>element);
            })
        }
        if (tipoNotEquals !== undefined && tipoNotEquals !== null) {
            queryParameters = queryParameters.set('tipo.notEquals', <any>tipoNotEquals);
        }
        if (tipoSpecified !== undefined && tipoSpecified !== null) {
            queryParameters = queryParameters.set('tipo.specified', <any>tipoSpecified);
        }
        if (totaleEquals !== undefined && totaleEquals !== null) {
            queryParameters = queryParameters.set('totale.equals', <any>totaleEquals);
        }
        if (totaleGreaterThan !== undefined && totaleGreaterThan !== null) {
            queryParameters = queryParameters.set('totale.greaterThan', <any>totaleGreaterThan);
        }
        if (totaleGreaterThanOrEqual !== undefined && totaleGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('totale.greaterThanOrEqual', <any>totaleGreaterThanOrEqual);
        }
        if (totaleIn) {
            totaleIn.forEach((element) => {
                queryParameters = queryParameters.append('totale.in', <any>element);
            })
        }
        if (totaleLessThan !== undefined && totaleLessThan !== null) {
            queryParameters = queryParameters.set('totale.lessThan', <any>totaleLessThan);
        }
        if (totaleLessThanOrEqual !== undefined && totaleLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('totale.lessThanOrEqual', <any>totaleLessThanOrEqual);
        }
        if (totaleNotEquals !== undefined && totaleNotEquals !== null) {
            queryParameters = queryParameters.set('totale.notEquals', <any>totaleNotEquals);
        }
        if (totaleSpecified !== undefined && totaleSpecified !== null) {
            queryParameters = queryParameters.set('totale.specified', <any>totaleSpecified);
        }
        if (totimponibileEquals !== undefined && totimponibileEquals !== null) {
            queryParameters = queryParameters.set('totimponibile.equals', <any>totimponibileEquals);
        }
        if (totimponibileGreaterThan !== undefined && totimponibileGreaterThan !== null) {
            queryParameters = queryParameters.set('totimponibile.greaterThan', <any>totimponibileGreaterThan);
        }
        if (totimponibileGreaterThanOrEqual !== undefined && totimponibileGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('totimponibile.greaterThanOrEqual', <any>totimponibileGreaterThanOrEqual);
        }
        if (totimponibileIn) {
            totimponibileIn.forEach((element) => {
                queryParameters = queryParameters.append('totimponibile.in', <any>element);
            })
        }
        if (totimponibileLessThan !== undefined && totimponibileLessThan !== null) {
            queryParameters = queryParameters.set('totimponibile.lessThan', <any>totimponibileLessThan);
        }
        if (totimponibileLessThanOrEqual !== undefined && totimponibileLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('totimponibile.lessThanOrEqual', <any>totimponibileLessThanOrEqual);
        }
        if (totimponibileNotEquals !== undefined && totimponibileNotEquals !== null) {
            queryParameters = queryParameters.set('totimponibile.notEquals', <any>totimponibileNotEquals);
        }
        if (totimponibileSpecified !== undefined && totimponibileSpecified !== null) {
            queryParameters = queryParameters.set('totimponibile.specified', <any>totimponibileSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/apollo-documents/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createApolloDocument
     * 
     * @param body apolloDocumentDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createApolloDocumentUsingPOST(body: ApolloDocumentDTO, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentDTO>;
    public createApolloDocumentUsingPOST(body: ApolloDocumentDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentDTO>>;
    public createApolloDocumentUsingPOST(body: ApolloDocumentDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentDTO>>;
    public createApolloDocumentUsingPOST(body: ApolloDocumentDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createApolloDocumentUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ApolloDocumentDTO>('post',`${this.basePath}/api/apollo-documents`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteApolloDocument
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteApolloDocumentUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteApolloDocumentUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteApolloDocumentUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteApolloDocumentUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteApolloDocumentUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/apollo-documents/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllApolloDocuments
     * 
     * @param capContains 
     * @param capDoesNotContain 
     * @param capEquals 
     * @param capIn 
     * @param capNotEquals 
     * @param capSpecified 
     * @param cittContains 
     * @param cittDoesNotContain 
     * @param cittEquals 
     * @param cittIn 
     * @param cittNotEquals 
     * @param cittSpecified 
     * @param clienteEquals 
     * @param clienteIn 
     * @param clienteNotEquals 
     * @param clienteSpecified 
     * @param codfiscContains 
     * @param codfiscDoesNotContain 
     * @param codfiscEquals 
     * @param codfiscIn 
     * @param codfiscNotEquals 
     * @param codfiscSpecified 
     * @param codiceInvioContains 
     * @param codiceInvioDoesNotContain 
     * @param codiceInvioEquals 
     * @param codiceInvioIn 
     * @param codiceInvioNotEquals 
     * @param codiceInvioSpecified 
     * @param contoEquals 
     * @param contoGreaterThan 
     * @param contoGreaterThanOrEqual 
     * @param contoIn 
     * @param contoLessThan 
     * @param contoLessThanOrEqual 
     * @param contoNotEquals 
     * @param contoSpecified 
     * @param contrintegpercEquals 
     * @param contrintegpercGreaterThan 
     * @param contrintegpercGreaterThanOrEqual 
     * @param contrintegpercIn 
     * @param contrintegpercLessThan 
     * @param contrintegpercLessThanOrEqual 
     * @param contrintegpercNotEquals 
     * @param contrintegpercSpecified 
     * @param contrintegvalEquals 
     * @param contrintegvalGreaterThan 
     * @param contrintegvalGreaterThanOrEqual 
     * @param contrintegvalIn 
     * @param contrintegvalLessThan 
     * @param contrintegvalLessThanOrEqual 
     * @param contrintegvalNotEquals 
     * @param contrintegvalSpecified 
     * @param dataEquals 
     * @param dataGreaterThan 
     * @param dataGreaterThanOrEqual 
     * @param dataIn0ChronologyCalendarType 
     * @param dataIn0ChronologyId 
     * @param dataIn0DayOfMonth 
     * @param dataIn0DayOfWeek 
     * @param dataIn0DayOfYear 
     * @param dataIn0EraValue 
     * @param dataIn0LeapYear 
     * @param dataIn0Month 
     * @param dataIn0MonthValue 
     * @param dataIn0Year 
     * @param dataLessThan 
     * @param dataLessThanOrEqual 
     * @param dataNotEquals 
     * @param dataSpecified 
     * @param datainsEquals 
     * @param datainsGreaterThan 
     * @param datainsGreaterThanOrEqual 
     * @param datainsIn0DayOfMonth 
     * @param datainsIn0DayOfWeek 
     * @param datainsIn0DayOfYear 
     * @param datainsIn0Hour 
     * @param datainsIn0Minute 
     * @param datainsIn0Month 
     * @param datainsIn0MonthValue 
     * @param datainsIn0Nano 
     * @param datainsIn0OffsetId 
     * @param datainsIn0OffsetRulesFixedOffset 
     * @param datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator 
     * @param datainsIn0OffsetRulesTransitionRules0DayOfWeek 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeHour 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeMinute 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeNano 
     * @param datainsIn0OffsetRulesTransitionRules0LocalTimeSecond 
     * @param datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay 
     * @param datainsIn0OffsetRulesTransitionRules0Month 
     * @param datainsIn0OffsetRulesTransitionRules0TimeDefinition 
     * @param datainsIn0OffsetRulesTransitions0DateTimeAfter 
     * @param datainsIn0OffsetRulesTransitions0DateTimeBefore 
     * @param datainsIn0OffsetRulesTransitions0DurationNano 
     * @param datainsIn0OffsetRulesTransitions0DurationNegative 
     * @param datainsIn0OffsetRulesTransitions0DurationSeconds 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0DateBased 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated 
     * @param datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased 
     * @param datainsIn0OffsetRulesTransitions0DurationZero 
     * @param datainsIn0OffsetRulesTransitions0Gap 
     * @param datainsIn0OffsetRulesTransitions0Instant 
     * @param datainsIn0OffsetRulesTransitions0Overlap 
     * @param datainsIn0OffsetTotalSeconds 
     * @param datainsIn0Second 
     * @param datainsIn0Year 
     * @param datainsIn0ZoneId 
     * @param datainsIn0ZoneRulesFixedOffset 
     * @param datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator 
     * @param datainsIn0ZoneRulesTransitionRules0DayOfWeek 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeHour 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeMinute 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeNano 
     * @param datainsIn0ZoneRulesTransitionRules0LocalTimeSecond 
     * @param datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay 
     * @param datainsIn0ZoneRulesTransitionRules0Month 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetAfterId 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetBeforeId 
     * @param datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0StandardOffsetId 
     * @param datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds 
     * @param datainsIn0ZoneRulesTransitionRules0TimeDefinition 
     * @param datainsIn0ZoneRulesTransitions0DateTimeAfter 
     * @param datainsIn0ZoneRulesTransitions0DateTimeBefore 
     * @param datainsIn0ZoneRulesTransitions0DurationNano 
     * @param datainsIn0ZoneRulesTransitions0DurationNegative 
     * @param datainsIn0ZoneRulesTransitions0DurationSeconds 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0DateBased 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated 
     * @param datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased 
     * @param datainsIn0ZoneRulesTransitions0DurationZero 
     * @param datainsIn0ZoneRulesTransitions0Gap 
     * @param datainsIn0ZoneRulesTransitions0Instant 
     * @param datainsIn0ZoneRulesTransitions0OffsetAfterId 
     * @param datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds 
     * @param datainsIn0ZoneRulesTransitions0OffsetBeforeId 
     * @param datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds 
     * @param datainsIn0ZoneRulesTransitions0Overlap 
     * @param datainsLessThan 
     * @param datainsLessThanOrEqual 
     * @param datainsNotEquals 
     * @param datainsSpecified 
     * @param dataregistrazioneEquals 
     * @param dataregistrazioneGreaterThan 
     * @param dataregistrazioneGreaterThanOrEqual 
     * @param dataregistrazioneIn0ChronologyCalendarType 
     * @param dataregistrazioneIn0ChronologyId 
     * @param dataregistrazioneIn0DayOfMonth 
     * @param dataregistrazioneIn0DayOfWeek 
     * @param dataregistrazioneIn0DayOfYear 
     * @param dataregistrazioneIn0EraValue 
     * @param dataregistrazioneIn0LeapYear 
     * @param dataregistrazioneIn0Month 
     * @param dataregistrazioneIn0MonthValue 
     * @param dataregistrazioneIn0Year 
     * @param dataregistrazioneLessThan 
     * @param dataregistrazioneLessThanOrEqual 
     * @param dataregistrazioneNotEquals 
     * @param dataregistrazioneSpecified 
     * @param fornitoreEquals 
     * @param fornitoreIn 
     * @param fornitoreNotEquals 
     * @param fornitoreSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param idanagraficaEquals 
     * @param idanagraficaGreaterThan 
     * @param idanagraficaGreaterThanOrEqual 
     * @param idanagraficaIn 
     * @param idanagraficaLessThan 
     * @param idanagraficaLessThanOrEqual 
     * @param idanagraficaNotEquals 
     * @param idanagraficaSpecified 
     * @param idaziendaEquals 
     * @param idaziendaGreaterThan 
     * @param idaziendaGreaterThanOrEqual 
     * @param idaziendaIn 
     * @param idaziendaLessThan 
     * @param idaziendaLessThanOrEqual 
     * @param idaziendaNotEquals 
     * @param idaziendaSpecified 
     * @param iddocumentoContains 
     * @param iddocumentoDoesNotContain 
     * @param iddocumentoEquals 
     * @param iddocumentoIn 
     * @param iddocumentoNotEquals 
     * @param iddocumentoSpecified 
     * @param idsottocontoContains 
     * @param idsottocontoDoesNotContain 
     * @param idsottocontoEquals 
     * @param idsottocontoIn 
     * @param idsottocontoNotEquals 
     * @param idsottocontoSpecified 
     * @param indirizzoContains 
     * @param indirizzoDoesNotContain 
     * @param indirizzoEquals 
     * @param indirizzoIn 
     * @param indirizzoNotEquals 
     * @param indirizzoSpecified 
     * @param intestazioneContains 
     * @param intestazioneDoesNotContain 
     * @param intestazioneEquals 
     * @param intestazioneIn 
     * @param intestazioneNotEquals 
     * @param intestazioneSpecified 
     * @param ivaEquals 
     * @param ivaGreaterThan 
     * @param ivaGreaterThanOrEqual 
     * @param ivaIn 
     * @param ivaLessThan 
     * @param ivaLessThanOrEqual 
     * @param ivaNotEquals 
     * @param ivaSpecified 
     * @param ivasinoEquals 
     * @param ivasinoIn 
     * @param ivasinoNotEquals 
     * @param ivasinoSpecified 
     * @param mdopagEquals 
     * @param mdopagGreaterThan 
     * @param mdopagGreaterThanOrEqual 
     * @param mdopagIn 
     * @param mdopagLessThan 
     * @param mdopagLessThanOrEqual 
     * @param mdopagNotEquals 
     * @param mdopagSpecified 
     * @param ndocContains 
     * @param ndocDoesNotContain 
     * @param ndocEquals 
     * @param ndocIn 
     * @param ndocNotEquals 
     * @param ndocSpecified 
     * @param ndocSuffEquals 
     * @param ndocSuffGreaterThan 
     * @param ndocSuffGreaterThanOrEqual 
     * @param ndocSuffIn 
     * @param ndocSuffLessThan 
     * @param ndocSuffLessThanOrEqual 
     * @param ndocSuffNotEquals 
     * @param ndocSuffSpecified 
     * @param noteContains 
     * @param noteDoesNotContain 
     * @param noteEquals 
     * @param noteIn 
     * @param noteNotEquals 
     * @param noteSpecified 
     * @param opeinsContains 
     * @param opeinsDoesNotContain 
     * @param opeinsEquals 
     * @param opeinsIn 
     * @param opeinsNotEquals 
     * @param opeinsSpecified 
     * @param page Page number of the requested page
     * @param pecContains 
     * @param pecDoesNotContain 
     * @param pecEquals 
     * @param pecIn 
     * @param pecNotEquals 
     * @param pecSpecified 
     * @param percentIvaEquals 
     * @param percentIvaGreaterThan 
     * @param percentIvaGreaterThanOrEqual 
     * @param percentIvaIn 
     * @param percentIvaLessThan 
     * @param percentIvaLessThanOrEqual 
     * @param percentIvaNotEquals 
     * @param percentIvaSpecified 
     * @param percritenutaEquals 
     * @param percritenutaGreaterThan 
     * @param percritenutaGreaterThanOrEqual 
     * @param percritenutaIn 
     * @param percritenutaLessThan 
     * @param percritenutaLessThanOrEqual 
     * @param percritenutaNotEquals 
     * @param percritenutaSpecified 
     * @param pivaContains 
     * @param pivaDoesNotContain 
     * @param pivaEquals 
     * @param pivaIn 
     * @param pivaNotEquals 
     * @param pivaSpecified 
     * @param protSuffEquals 
     * @param protSuffGreaterThan 
     * @param protSuffGreaterThanOrEqual 
     * @param protSuffIn 
     * @param protSuffLessThan 
     * @param protSuffLessThanOrEqual 
     * @param protSuffNotEquals 
     * @param protSuffSpecified 
     * @param protocolloEquals 
     * @param protocolloGreaterThan 
     * @param protocolloGreaterThanOrEqual 
     * @param protocolloIn 
     * @param protocolloLessThan 
     * @param protocolloLessThanOrEqual 
     * @param protocolloNotEquals 
     * @param protocolloSpecified 
     * @param provContains 
     * @param provDoesNotContain 
     * @param provEquals 
     * @param provIn 
     * @param provNotEquals 
     * @param provSpecified 
     * @param ritenutaEquals 
     * @param ritenutaGreaterThan 
     * @param ritenutaGreaterThanOrEqual 
     * @param ritenutaIn 
     * @param ritenutaLessThan 
     * @param ritenutaLessThanOrEqual 
     * @param ritenutaNotEquals 
     * @param ritenutaSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param tipoContains 
     * @param tipoDoesNotContain 
     * @param tipoEquals 
     * @param tipoIn 
     * @param tipoNotEquals 
     * @param tipoSpecified 
     * @param totaleEquals 
     * @param totaleGreaterThan 
     * @param totaleGreaterThanOrEqual 
     * @param totaleIn 
     * @param totaleLessThan 
     * @param totaleLessThanOrEqual 
     * @param totaleNotEquals 
     * @param totaleSpecified 
     * @param totimponibileEquals 
     * @param totimponibileGreaterThan 
     * @param totimponibileGreaterThanOrEqual 
     * @param totimponibileIn 
     * @param totimponibileLessThan 
     * @param totimponibileLessThanOrEqual 
     * @param totimponibileNotEquals 
     * @param totimponibileSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, page?: number, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, size?: number, sort?: Array<string>, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ApolloDocumentDTO>>;
    public getAllApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, page?: number, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, size?: number, sort?: Array<string>, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApolloDocumentDTO>>>;
    public getAllApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, page?: number, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, size?: number, sort?: Array<string>, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApolloDocumentDTO>>>;
    public getAllApolloDocumentsUsingGET(capContains?: string, capDoesNotContain?: string, capEquals?: string, capIn?: Array<string>, capNotEquals?: string, capSpecified?: boolean, cittContains?: string, cittDoesNotContain?: string, cittEquals?: string, cittIn?: Array<string>, cittNotEquals?: string, cittSpecified?: boolean, clienteEquals?: boolean, clienteIn?: Array<boolean>, clienteNotEquals?: boolean, clienteSpecified?: boolean, codfiscContains?: string, codfiscDoesNotContain?: string, codfiscEquals?: string, codfiscIn?: Array<string>, codfiscNotEquals?: string, codfiscSpecified?: boolean, codiceInvioContains?: string, codiceInvioDoesNotContain?: string, codiceInvioEquals?: string, codiceInvioIn?: Array<string>, codiceInvioNotEquals?: string, codiceInvioSpecified?: boolean, contoEquals?: number, contoGreaterThan?: number, contoGreaterThanOrEqual?: number, contoIn?: Array<number>, contoLessThan?: number, contoLessThanOrEqual?: number, contoNotEquals?: number, contoSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, dataEquals?: string, dataGreaterThan?: string, dataGreaterThanOrEqual?: string, dataIn0ChronologyCalendarType?: string, dataIn0ChronologyId?: string, dataIn0DayOfMonth?: number, dataIn0DayOfWeek?: string, dataIn0DayOfYear?: number, dataIn0EraValue?: number, dataIn0LeapYear?: boolean, dataIn0Month?: string, dataIn0MonthValue?: number, dataIn0Year?: number, dataLessThan?: string, dataLessThanOrEqual?: string, dataNotEquals?: string, dataSpecified?: boolean, datainsEquals?: Date, datainsGreaterThan?: Date, datainsGreaterThanOrEqual?: Date, datainsIn0DayOfMonth?: number, datainsIn0DayOfWeek?: string, datainsIn0DayOfYear?: number, datainsIn0Hour?: number, datainsIn0Minute?: number, datainsIn0Month?: string, datainsIn0MonthValue?: number, datainsIn0Nano?: number, datainsIn0OffsetId?: string, datainsIn0OffsetRulesFixedOffset?: boolean, datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0OffsetRulesTransitionRules0DayOfWeek?: string, datainsIn0OffsetRulesTransitionRules0LocalTimeHour?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeMinute?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeNano?: number, datainsIn0OffsetRulesTransitionRules0LocalTimeSecond?: number, datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0OffsetRulesTransitionRules0Month?: string, datainsIn0OffsetRulesTransitionRules0TimeDefinition?: string, datainsIn0OffsetRulesTransitions0DateTimeAfter?: Date, datainsIn0OffsetRulesTransitions0DateTimeBefore?: Date, datainsIn0OffsetRulesTransitions0DurationNano?: number, datainsIn0OffsetRulesTransitions0DurationNegative?: boolean, datainsIn0OffsetRulesTransitions0DurationSeconds?: number, datainsIn0OffsetRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0OffsetRulesTransitions0DurationZero?: boolean, datainsIn0OffsetRulesTransitions0Gap?: boolean, datainsIn0OffsetRulesTransitions0Instant?: Date, datainsIn0OffsetRulesTransitions0Overlap?: boolean, datainsIn0OffsetTotalSeconds?: number, datainsIn0Second?: number, datainsIn0Year?: number, datainsIn0ZoneId?: string, datainsIn0ZoneRulesFixedOffset?: boolean, datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator?: number, datainsIn0ZoneRulesTransitionRules0DayOfWeek?: string, datainsIn0ZoneRulesTransitionRules0LocalTimeHour?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeMinute?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeNano?: number, datainsIn0ZoneRulesTransitionRules0LocalTimeSecond?: number, datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay?: boolean, datainsIn0ZoneRulesTransitionRules0Month?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterId?: string, datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0StandardOffsetId?: string, datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds?: number, datainsIn0ZoneRulesTransitionRules0TimeDefinition?: string, datainsIn0ZoneRulesTransitions0DateTimeAfter?: Date, datainsIn0ZoneRulesTransitions0DateTimeBefore?: Date, datainsIn0ZoneRulesTransitions0DurationNano?: number, datainsIn0ZoneRulesTransitions0DurationNegative?: boolean, datainsIn0ZoneRulesTransitions0DurationSeconds?: number, datainsIn0ZoneRulesTransitions0DurationUnits0DateBased?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated?: boolean, datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased?: boolean, datainsIn0ZoneRulesTransitions0DurationZero?: boolean, datainsIn0ZoneRulesTransitions0Gap?: boolean, datainsIn0ZoneRulesTransitions0Instant?: Date, datainsIn0ZoneRulesTransitions0OffsetAfterId?: string, datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds?: number, datainsIn0ZoneRulesTransitions0OffsetBeforeId?: string, datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds?: number, datainsIn0ZoneRulesTransitions0Overlap?: boolean, datainsLessThan?: Date, datainsLessThanOrEqual?: Date, datainsNotEquals?: Date, datainsSpecified?: boolean, dataregistrazioneEquals?: string, dataregistrazioneGreaterThan?: string, dataregistrazioneGreaterThanOrEqual?: string, dataregistrazioneIn0ChronologyCalendarType?: string, dataregistrazioneIn0ChronologyId?: string, dataregistrazioneIn0DayOfMonth?: number, dataregistrazioneIn0DayOfWeek?: string, dataregistrazioneIn0DayOfYear?: number, dataregistrazioneIn0EraValue?: number, dataregistrazioneIn0LeapYear?: boolean, dataregistrazioneIn0Month?: string, dataregistrazioneIn0MonthValue?: number, dataregistrazioneIn0Year?: number, dataregistrazioneLessThan?: string, dataregistrazioneLessThanOrEqual?: string, dataregistrazioneNotEquals?: string, dataregistrazioneSpecified?: boolean, fornitoreEquals?: boolean, fornitoreIn?: Array<boolean>, fornitoreNotEquals?: boolean, fornitoreSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idanagraficaEquals?: number, idanagraficaGreaterThan?: number, idanagraficaGreaterThanOrEqual?: number, idanagraficaIn?: Array<number>, idanagraficaLessThan?: number, idanagraficaLessThanOrEqual?: number, idanagraficaNotEquals?: number, idanagraficaSpecified?: boolean, idaziendaEquals?: number, idaziendaGreaterThan?: number, idaziendaGreaterThanOrEqual?: number, idaziendaIn?: Array<number>, idaziendaLessThan?: number, idaziendaLessThanOrEqual?: number, idaziendaNotEquals?: number, idaziendaSpecified?: boolean, iddocumentoContains?: string, iddocumentoDoesNotContain?: string, iddocumentoEquals?: string, iddocumentoIn?: Array<string>, iddocumentoNotEquals?: string, iddocumentoSpecified?: boolean, idsottocontoContains?: string, idsottocontoDoesNotContain?: string, idsottocontoEquals?: string, idsottocontoIn?: Array<string>, idsottocontoNotEquals?: string, idsottocontoSpecified?: boolean, indirizzoContains?: string, indirizzoDoesNotContain?: string, indirizzoEquals?: string, indirizzoIn?: Array<string>, indirizzoNotEquals?: string, indirizzoSpecified?: boolean, intestazioneContains?: string, intestazioneDoesNotContain?: string, intestazioneEquals?: string, intestazioneIn?: Array<string>, intestazioneNotEquals?: string, intestazioneSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, ivasinoEquals?: boolean, ivasinoIn?: Array<boolean>, ivasinoNotEquals?: boolean, ivasinoSpecified?: boolean, mdopagEquals?: number, mdopagGreaterThan?: number, mdopagGreaterThanOrEqual?: number, mdopagIn?: Array<number>, mdopagLessThan?: number, mdopagLessThanOrEqual?: number, mdopagNotEquals?: number, mdopagSpecified?: boolean, ndocContains?: string, ndocDoesNotContain?: string, ndocEquals?: string, ndocIn?: Array<string>, ndocNotEquals?: string, ndocSpecified?: boolean, ndocSuffEquals?: number, ndocSuffGreaterThan?: number, ndocSuffGreaterThanOrEqual?: number, ndocSuffIn?: Array<number>, ndocSuffLessThan?: number, ndocSuffLessThanOrEqual?: number, ndocSuffNotEquals?: number, ndocSuffSpecified?: boolean, noteContains?: string, noteDoesNotContain?: string, noteEquals?: string, noteIn?: Array<string>, noteNotEquals?: string, noteSpecified?: boolean, opeinsContains?: string, opeinsDoesNotContain?: string, opeinsEquals?: string, opeinsIn?: Array<string>, opeinsNotEquals?: string, opeinsSpecified?: boolean, page?: number, pecContains?: string, pecDoesNotContain?: string, pecEquals?: string, pecIn?: Array<string>, pecNotEquals?: string, pecSpecified?: boolean, percentIvaEquals?: number, percentIvaGreaterThan?: number, percentIvaGreaterThanOrEqual?: number, percentIvaIn?: Array<number>, percentIvaLessThan?: number, percentIvaLessThanOrEqual?: number, percentIvaNotEquals?: number, percentIvaSpecified?: boolean, percritenutaEquals?: number, percritenutaGreaterThan?: number, percritenutaGreaterThanOrEqual?: number, percritenutaIn?: Array<number>, percritenutaLessThan?: number, percritenutaLessThanOrEqual?: number, percritenutaNotEquals?: number, percritenutaSpecified?: boolean, pivaContains?: string, pivaDoesNotContain?: string, pivaEquals?: string, pivaIn?: Array<string>, pivaNotEquals?: string, pivaSpecified?: boolean, protSuffEquals?: number, protSuffGreaterThan?: number, protSuffGreaterThanOrEqual?: number, protSuffIn?: Array<number>, protSuffLessThan?: number, protSuffLessThanOrEqual?: number, protSuffNotEquals?: number, protSuffSpecified?: boolean, protocolloEquals?: number, protocolloGreaterThan?: number, protocolloGreaterThanOrEqual?: number, protocolloIn?: Array<number>, protocolloLessThan?: number, protocolloLessThanOrEqual?: number, protocolloNotEquals?: number, protocolloSpecified?: boolean, provContains?: string, provDoesNotContain?: string, provEquals?: string, provIn?: Array<string>, provNotEquals?: string, provSpecified?: boolean, ritenutaEquals?: number, ritenutaGreaterThan?: number, ritenutaGreaterThanOrEqual?: number, ritenutaIn?: Array<number>, ritenutaLessThan?: number, ritenutaLessThanOrEqual?: number, ritenutaNotEquals?: number, ritenutaSpecified?: boolean, size?: number, sort?: Array<string>, tipoContains?: string, tipoDoesNotContain?: string, tipoEquals?: string, tipoIn?: Array<string>, tipoNotEquals?: string, tipoSpecified?: boolean, totaleEquals?: number, totaleGreaterThan?: number, totaleGreaterThanOrEqual?: number, totaleIn?: Array<number>, totaleLessThan?: number, totaleLessThanOrEqual?: number, totaleNotEquals?: number, totaleSpecified?: boolean, totimponibileEquals?: number, totimponibileGreaterThan?: number, totimponibileGreaterThanOrEqual?: number, totimponibileIn?: Array<number>, totimponibileLessThan?: number, totimponibileLessThanOrEqual?: number, totimponibileNotEquals?: number, totimponibileSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






















































































































































































































































































































































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (capContains !== undefined && capContains !== null) {
            queryParameters = queryParameters.set('cap.contains', <any>capContains);
        }
        if (capDoesNotContain !== undefined && capDoesNotContain !== null) {
            queryParameters = queryParameters.set('cap.doesNotContain', <any>capDoesNotContain);
        }
        if (capEquals !== undefined && capEquals !== null) {
            queryParameters = queryParameters.set('cap.equals', <any>capEquals);
        }
        if (capIn) {
            capIn.forEach((element) => {
                queryParameters = queryParameters.append('cap.in', <any>element);
            })
        }
        if (capNotEquals !== undefined && capNotEquals !== null) {
            queryParameters = queryParameters.set('cap.notEquals', <any>capNotEquals);
        }
        if (capSpecified !== undefined && capSpecified !== null) {
            queryParameters = queryParameters.set('cap.specified', <any>capSpecified);
        }
        if (cittContains !== undefined && cittContains !== null) {
            queryParameters = queryParameters.set('citt.contains', <any>cittContains);
        }
        if (cittDoesNotContain !== undefined && cittDoesNotContain !== null) {
            queryParameters = queryParameters.set('citt.doesNotContain', <any>cittDoesNotContain);
        }
        if (cittEquals !== undefined && cittEquals !== null) {
            queryParameters = queryParameters.set('citt.equals', <any>cittEquals);
        }
        if (cittIn) {
            cittIn.forEach((element) => {
                queryParameters = queryParameters.append('citt.in', <any>element);
            })
        }
        if (cittNotEquals !== undefined && cittNotEquals !== null) {
            queryParameters = queryParameters.set('citt.notEquals', <any>cittNotEquals);
        }
        if (cittSpecified !== undefined && cittSpecified !== null) {
            queryParameters = queryParameters.set('citt.specified', <any>cittSpecified);
        }
        if (clienteEquals !== undefined && clienteEquals !== null) {
            queryParameters = queryParameters.set('cliente.equals', <any>clienteEquals);
        }
        if (clienteIn) {
            clienteIn.forEach((element) => {
                queryParameters = queryParameters.append('cliente.in', <any>element);
            })
        }
        if (clienteNotEquals !== undefined && clienteNotEquals !== null) {
            queryParameters = queryParameters.set('cliente.notEquals', <any>clienteNotEquals);
        }
        if (clienteSpecified !== undefined && clienteSpecified !== null) {
            queryParameters = queryParameters.set('cliente.specified', <any>clienteSpecified);
        }
        if (codfiscContains !== undefined && codfiscContains !== null) {
            queryParameters = queryParameters.set('codfisc.contains', <any>codfiscContains);
        }
        if (codfiscDoesNotContain !== undefined && codfiscDoesNotContain !== null) {
            queryParameters = queryParameters.set('codfisc.doesNotContain', <any>codfiscDoesNotContain);
        }
        if (codfiscEquals !== undefined && codfiscEquals !== null) {
            queryParameters = queryParameters.set('codfisc.equals', <any>codfiscEquals);
        }
        if (codfiscIn) {
            codfiscIn.forEach((element) => {
                queryParameters = queryParameters.append('codfisc.in', <any>element);
            })
        }
        if (codfiscNotEquals !== undefined && codfiscNotEquals !== null) {
            queryParameters = queryParameters.set('codfisc.notEquals', <any>codfiscNotEquals);
        }
        if (codfiscSpecified !== undefined && codfiscSpecified !== null) {
            queryParameters = queryParameters.set('codfisc.specified', <any>codfiscSpecified);
        }
        if (codiceInvioContains !== undefined && codiceInvioContains !== null) {
            queryParameters = queryParameters.set('codiceInvio.contains', <any>codiceInvioContains);
        }
        if (codiceInvioDoesNotContain !== undefined && codiceInvioDoesNotContain !== null) {
            queryParameters = queryParameters.set('codiceInvio.doesNotContain', <any>codiceInvioDoesNotContain);
        }
        if (codiceInvioEquals !== undefined && codiceInvioEquals !== null) {
            queryParameters = queryParameters.set('codiceInvio.equals', <any>codiceInvioEquals);
        }
        if (codiceInvioIn) {
            codiceInvioIn.forEach((element) => {
                queryParameters = queryParameters.append('codiceInvio.in', <any>element);
            })
        }
        if (codiceInvioNotEquals !== undefined && codiceInvioNotEquals !== null) {
            queryParameters = queryParameters.set('codiceInvio.notEquals', <any>codiceInvioNotEquals);
        }
        if (codiceInvioSpecified !== undefined && codiceInvioSpecified !== null) {
            queryParameters = queryParameters.set('codiceInvio.specified', <any>codiceInvioSpecified);
        }
        if (contoEquals !== undefined && contoEquals !== null) {
            queryParameters = queryParameters.set('conto.equals', <any>contoEquals);
        }
        if (contoGreaterThan !== undefined && contoGreaterThan !== null) {
            queryParameters = queryParameters.set('conto.greaterThan', <any>contoGreaterThan);
        }
        if (contoGreaterThanOrEqual !== undefined && contoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('conto.greaterThanOrEqual', <any>contoGreaterThanOrEqual);
        }
        if (contoIn) {
            contoIn.forEach((element) => {
                queryParameters = queryParameters.append('conto.in', <any>element);
            })
        }
        if (contoLessThan !== undefined && contoLessThan !== null) {
            queryParameters = queryParameters.set('conto.lessThan', <any>contoLessThan);
        }
        if (contoLessThanOrEqual !== undefined && contoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('conto.lessThanOrEqual', <any>contoLessThanOrEqual);
        }
        if (contoNotEquals !== undefined && contoNotEquals !== null) {
            queryParameters = queryParameters.set('conto.notEquals', <any>contoNotEquals);
        }
        if (contoSpecified !== undefined && contoSpecified !== null) {
            queryParameters = queryParameters.set('conto.specified', <any>contoSpecified);
        }
        if (contrintegpercEquals !== undefined && contrintegpercEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.equals', <any>contrintegpercEquals);
        }
        if (contrintegpercGreaterThan !== undefined && contrintegpercGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThan', <any>contrintegpercGreaterThan);
        }
        if (contrintegpercGreaterThanOrEqual !== undefined && contrintegpercGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThanOrEqual', <any>contrintegpercGreaterThanOrEqual);
        }
        if (contrintegpercIn) {
            contrintegpercIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegperc.in', <any>element);
            })
        }
        if (contrintegpercLessThan !== undefined && contrintegpercLessThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThan', <any>contrintegpercLessThan);
        }
        if (contrintegpercLessThanOrEqual !== undefined && contrintegpercLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThanOrEqual', <any>contrintegpercLessThanOrEqual);
        }
        if (contrintegpercNotEquals !== undefined && contrintegpercNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.notEquals', <any>contrintegpercNotEquals);
        }
        if (contrintegpercSpecified !== undefined && contrintegpercSpecified !== null) {
            queryParameters = queryParameters.set('contrintegperc.specified', <any>contrintegpercSpecified);
        }
        if (contrintegvalEquals !== undefined && contrintegvalEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.equals', <any>contrintegvalEquals);
        }
        if (contrintegvalGreaterThan !== undefined && contrintegvalGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThan', <any>contrintegvalGreaterThan);
        }
        if (contrintegvalGreaterThanOrEqual !== undefined && contrintegvalGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThanOrEqual', <any>contrintegvalGreaterThanOrEqual);
        }
        if (contrintegvalIn) {
            contrintegvalIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegval.in', <any>element);
            })
        }
        if (contrintegvalLessThan !== undefined && contrintegvalLessThan !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThan', <any>contrintegvalLessThan);
        }
        if (contrintegvalLessThanOrEqual !== undefined && contrintegvalLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThanOrEqual', <any>contrintegvalLessThanOrEqual);
        }
        if (contrintegvalNotEquals !== undefined && contrintegvalNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.notEquals', <any>contrintegvalNotEquals);
        }
        if (contrintegvalSpecified !== undefined && contrintegvalSpecified !== null) {
            queryParameters = queryParameters.set('contrintegval.specified', <any>contrintegvalSpecified);
        }
        if (dataEquals !== undefined && dataEquals !== null) {
            queryParameters = queryParameters.set('data.equals', <any>dataEquals);
        }
        if (dataGreaterThan !== undefined && dataGreaterThan !== null) {
            queryParameters = queryParameters.set('data.greaterThan', <any>dataGreaterThan);
        }
        if (dataGreaterThanOrEqual !== undefined && dataGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('data.greaterThanOrEqual', <any>dataGreaterThanOrEqual);
        }
        if (dataIn0ChronologyCalendarType !== undefined && dataIn0ChronologyCalendarType !== null) {
            queryParameters = queryParameters.set('data.in[0].chronology.calendarType', <any>dataIn0ChronologyCalendarType);
        }
        if (dataIn0ChronologyId !== undefined && dataIn0ChronologyId !== null) {
            queryParameters = queryParameters.set('data.in[0].chronology.id', <any>dataIn0ChronologyId);
        }
        if (dataIn0DayOfMonth !== undefined && dataIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfMonth', <any>dataIn0DayOfMonth);
        }
        if (dataIn0DayOfWeek !== undefined && dataIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfWeek', <any>dataIn0DayOfWeek);
        }
        if (dataIn0DayOfYear !== undefined && dataIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('data.in[0].dayOfYear', <any>dataIn0DayOfYear);
        }
        if (dataIn0EraValue !== undefined && dataIn0EraValue !== null) {
            queryParameters = queryParameters.set('data.in[0].era.value', <any>dataIn0EraValue);
        }
        if (dataIn0LeapYear !== undefined && dataIn0LeapYear !== null) {
            queryParameters = queryParameters.set('data.in[0].leapYear', <any>dataIn0LeapYear);
        }
        if (dataIn0Month !== undefined && dataIn0Month !== null) {
            queryParameters = queryParameters.set('data.in[0].month', <any>dataIn0Month);
        }
        if (dataIn0MonthValue !== undefined && dataIn0MonthValue !== null) {
            queryParameters = queryParameters.set('data.in[0].monthValue', <any>dataIn0MonthValue);
        }
        if (dataIn0Year !== undefined && dataIn0Year !== null) {
            queryParameters = queryParameters.set('data.in[0].year', <any>dataIn0Year);
        }
        if (dataLessThan !== undefined && dataLessThan !== null) {
            queryParameters = queryParameters.set('data.lessThan', <any>dataLessThan);
        }
        if (dataLessThanOrEqual !== undefined && dataLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('data.lessThanOrEqual', <any>dataLessThanOrEqual);
        }
        if (dataNotEquals !== undefined && dataNotEquals !== null) {
            queryParameters = queryParameters.set('data.notEquals', <any>dataNotEquals);
        }
        if (dataSpecified !== undefined && dataSpecified !== null) {
            queryParameters = queryParameters.set('data.specified', <any>dataSpecified);
        }
        if (datainsEquals !== undefined && datainsEquals !== null) {
            queryParameters = queryParameters.set('datains.equals', <any>datainsEquals.toISOString());
        }
        if (datainsGreaterThan !== undefined && datainsGreaterThan !== null) {
            queryParameters = queryParameters.set('datains.greaterThan', <any>datainsGreaterThan.toISOString());
        }
        if (datainsGreaterThanOrEqual !== undefined && datainsGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('datains.greaterThanOrEqual', <any>datainsGreaterThanOrEqual.toISOString());
        }
        if (datainsIn0DayOfMonth !== undefined && datainsIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfMonth', <any>datainsIn0DayOfMonth);
        }
        if (datainsIn0DayOfWeek !== undefined && datainsIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfWeek', <any>datainsIn0DayOfWeek);
        }
        if (datainsIn0DayOfYear !== undefined && datainsIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('datains.in[0].dayOfYear', <any>datainsIn0DayOfYear);
        }
        if (datainsIn0Hour !== undefined && datainsIn0Hour !== null) {
            queryParameters = queryParameters.set('datains.in[0].hour', <any>datainsIn0Hour);
        }
        if (datainsIn0Minute !== undefined && datainsIn0Minute !== null) {
            queryParameters = queryParameters.set('datains.in[0].minute', <any>datainsIn0Minute);
        }
        if (datainsIn0Month !== undefined && datainsIn0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].month', <any>datainsIn0Month);
        }
        if (datainsIn0MonthValue !== undefined && datainsIn0MonthValue !== null) {
            queryParameters = queryParameters.set('datains.in[0].monthValue', <any>datainsIn0MonthValue);
        }
        if (datainsIn0Nano !== undefined && datainsIn0Nano !== null) {
            queryParameters = queryParameters.set('datains.in[0].nano', <any>datainsIn0Nano);
        }
        if (datainsIn0OffsetId !== undefined && datainsIn0OffsetId !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.id', <any>datainsIn0OffsetId);
        }
        if (datainsIn0OffsetRulesFixedOffset !== undefined && datainsIn0OffsetRulesFixedOffset !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.fixedOffset', <any>datainsIn0OffsetRulesFixedOffset);
        }
        if (datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator !== undefined && datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].dayOfMonthIndicator', <any>datainsIn0OffsetRulesTransitionRules0DayOfMonthIndicator);
        }
        if (datainsIn0OffsetRulesTransitionRules0DayOfWeek !== undefined && datainsIn0OffsetRulesTransitionRules0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].dayOfWeek', <any>datainsIn0OffsetRulesTransitionRules0DayOfWeek);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeHour !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeHour !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.hour', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeHour);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeMinute !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeMinute !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.minute', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeMinute);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeNano !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.nano', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeNano);
        }
        if (datainsIn0OffsetRulesTransitionRules0LocalTimeSecond !== undefined && datainsIn0OffsetRulesTransitionRules0LocalTimeSecond !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].localTime.second', <any>datainsIn0OffsetRulesTransitionRules0LocalTimeSecond);
        }
        if (datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay !== undefined && datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].midnightEndOfDay', <any>datainsIn0OffsetRulesTransitionRules0MidnightEndOfDay);
        }
        if (datainsIn0OffsetRulesTransitionRules0Month !== undefined && datainsIn0OffsetRulesTransitionRules0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].month', <any>datainsIn0OffsetRulesTransitionRules0Month);
        }
        if (datainsIn0OffsetRulesTransitionRules0TimeDefinition !== undefined && datainsIn0OffsetRulesTransitionRules0TimeDefinition !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitionRules[0].timeDefinition', <any>datainsIn0OffsetRulesTransitionRules0TimeDefinition);
        }
        if (datainsIn0OffsetRulesTransitions0DateTimeAfter !== undefined && datainsIn0OffsetRulesTransitions0DateTimeAfter !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].dateTimeAfter', <any>datainsIn0OffsetRulesTransitions0DateTimeAfter.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0DateTimeBefore !== undefined && datainsIn0OffsetRulesTransitions0DateTimeBefore !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].dateTimeBefore', <any>datainsIn0OffsetRulesTransitions0DateTimeBefore.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0DurationNano !== undefined && datainsIn0OffsetRulesTransitions0DurationNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.nano', <any>datainsIn0OffsetRulesTransitions0DurationNano);
        }
        if (datainsIn0OffsetRulesTransitions0DurationNegative !== undefined && datainsIn0OffsetRulesTransitions0DurationNegative !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.negative', <any>datainsIn0OffsetRulesTransitions0DurationNegative);
        }
        if (datainsIn0OffsetRulesTransitions0DurationSeconds !== undefined && datainsIn0OffsetRulesTransitions0DurationSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.seconds', <any>datainsIn0OffsetRulesTransitions0DurationSeconds);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0DateBased !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0DateBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].dateBased', <any>datainsIn0OffsetRulesTransitions0DurationUnits0DateBased);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].durationEstimated', <any>datainsIn0OffsetRulesTransitions0DurationUnits0DurationEstimated);
        }
        if (datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased !== undefined && datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.units[0].timeBased', <any>datainsIn0OffsetRulesTransitions0DurationUnits0TimeBased);
        }
        if (datainsIn0OffsetRulesTransitions0DurationZero !== undefined && datainsIn0OffsetRulesTransitions0DurationZero !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].duration.zero', <any>datainsIn0OffsetRulesTransitions0DurationZero);
        }
        if (datainsIn0OffsetRulesTransitions0Gap !== undefined && datainsIn0OffsetRulesTransitions0Gap !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].gap', <any>datainsIn0OffsetRulesTransitions0Gap);
        }
        if (datainsIn0OffsetRulesTransitions0Instant !== undefined && datainsIn0OffsetRulesTransitions0Instant !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].instant', <any>datainsIn0OffsetRulesTransitions0Instant.toISOString());
        }
        if (datainsIn0OffsetRulesTransitions0Overlap !== undefined && datainsIn0OffsetRulesTransitions0Overlap !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.rules.transitions[0].overlap', <any>datainsIn0OffsetRulesTransitions0Overlap);
        }
        if (datainsIn0OffsetTotalSeconds !== undefined && datainsIn0OffsetTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].offset.totalSeconds', <any>datainsIn0OffsetTotalSeconds);
        }
        if (datainsIn0Second !== undefined && datainsIn0Second !== null) {
            queryParameters = queryParameters.set('datains.in[0].second', <any>datainsIn0Second);
        }
        if (datainsIn0Year !== undefined && datainsIn0Year !== null) {
            queryParameters = queryParameters.set('datains.in[0].year', <any>datainsIn0Year);
        }
        if (datainsIn0ZoneId !== undefined && datainsIn0ZoneId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.id', <any>datainsIn0ZoneId);
        }
        if (datainsIn0ZoneRulesFixedOffset !== undefined && datainsIn0ZoneRulesFixedOffset !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.fixedOffset', <any>datainsIn0ZoneRulesFixedOffset);
        }
        if (datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator !== undefined && datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].dayOfMonthIndicator', <any>datainsIn0ZoneRulesTransitionRules0DayOfMonthIndicator);
        }
        if (datainsIn0ZoneRulesTransitionRules0DayOfWeek !== undefined && datainsIn0ZoneRulesTransitionRules0DayOfWeek !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].dayOfWeek', <any>datainsIn0ZoneRulesTransitionRules0DayOfWeek);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeHour !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeHour !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.hour', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeHour);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeMinute !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeMinute !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.minute', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeMinute);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeNano !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.nano', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeNano);
        }
        if (datainsIn0ZoneRulesTransitionRules0LocalTimeSecond !== undefined && datainsIn0ZoneRulesTransitionRules0LocalTimeSecond !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].localTime.second', <any>datainsIn0ZoneRulesTransitionRules0LocalTimeSecond);
        }
        if (datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay !== undefined && datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].midnightEndOfDay', <any>datainsIn0ZoneRulesTransitionRules0MidnightEndOfDay);
        }
        if (datainsIn0ZoneRulesTransitionRules0Month !== undefined && datainsIn0ZoneRulesTransitionRules0Month !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].month', <any>datainsIn0ZoneRulesTransitionRules0Month);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetAfterId !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetAfterId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetAfter.id', <any>datainsIn0ZoneRulesTransitionRules0OffsetAfterId);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetAfter.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0OffsetAfterTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetBeforeId !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetBeforeId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetBefore.id', <any>datainsIn0ZoneRulesTransitionRules0OffsetBeforeId);
        }
        if (datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].offsetBefore.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0OffsetBeforeTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0StandardOffsetId !== undefined && datainsIn0ZoneRulesTransitionRules0StandardOffsetId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].standardOffset.id', <any>datainsIn0ZoneRulesTransitionRules0StandardOffsetId);
        }
        if (datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds !== undefined && datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].standardOffset.totalSeconds', <any>datainsIn0ZoneRulesTransitionRules0StandardOffsetTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitionRules0TimeDefinition !== undefined && datainsIn0ZoneRulesTransitionRules0TimeDefinition !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitionRules[0].timeDefinition', <any>datainsIn0ZoneRulesTransitionRules0TimeDefinition);
        }
        if (datainsIn0ZoneRulesTransitions0DateTimeAfter !== undefined && datainsIn0ZoneRulesTransitions0DateTimeAfter !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].dateTimeAfter', <any>datainsIn0ZoneRulesTransitions0DateTimeAfter.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0DateTimeBefore !== undefined && datainsIn0ZoneRulesTransitions0DateTimeBefore !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].dateTimeBefore', <any>datainsIn0ZoneRulesTransitions0DateTimeBefore.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0DurationNano !== undefined && datainsIn0ZoneRulesTransitions0DurationNano !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.nano', <any>datainsIn0ZoneRulesTransitions0DurationNano);
        }
        if (datainsIn0ZoneRulesTransitions0DurationNegative !== undefined && datainsIn0ZoneRulesTransitions0DurationNegative !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.negative', <any>datainsIn0ZoneRulesTransitions0DurationNegative);
        }
        if (datainsIn0ZoneRulesTransitions0DurationSeconds !== undefined && datainsIn0ZoneRulesTransitions0DurationSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.seconds', <any>datainsIn0ZoneRulesTransitions0DurationSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0DateBased !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0DateBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].dateBased', <any>datainsIn0ZoneRulesTransitions0DurationUnits0DateBased);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].durationEstimated', <any>datainsIn0ZoneRulesTransitions0DurationUnits0DurationEstimated);
        }
        if (datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased !== undefined && datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.units[0].timeBased', <any>datainsIn0ZoneRulesTransitions0DurationUnits0TimeBased);
        }
        if (datainsIn0ZoneRulesTransitions0DurationZero !== undefined && datainsIn0ZoneRulesTransitions0DurationZero !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].duration.zero', <any>datainsIn0ZoneRulesTransitions0DurationZero);
        }
        if (datainsIn0ZoneRulesTransitions0Gap !== undefined && datainsIn0ZoneRulesTransitions0Gap !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].gap', <any>datainsIn0ZoneRulesTransitions0Gap);
        }
        if (datainsIn0ZoneRulesTransitions0Instant !== undefined && datainsIn0ZoneRulesTransitions0Instant !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].instant', <any>datainsIn0ZoneRulesTransitions0Instant.toISOString());
        }
        if (datainsIn0ZoneRulesTransitions0OffsetAfterId !== undefined && datainsIn0ZoneRulesTransitions0OffsetAfterId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetAfter.id', <any>datainsIn0ZoneRulesTransitions0OffsetAfterId);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds !== undefined && datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetAfter.totalSeconds', <any>datainsIn0ZoneRulesTransitions0OffsetAfterTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetBeforeId !== undefined && datainsIn0ZoneRulesTransitions0OffsetBeforeId !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetBefore.id', <any>datainsIn0ZoneRulesTransitions0OffsetBeforeId);
        }
        if (datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds !== undefined && datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].offsetBefore.totalSeconds', <any>datainsIn0ZoneRulesTransitions0OffsetBeforeTotalSeconds);
        }
        if (datainsIn0ZoneRulesTransitions0Overlap !== undefined && datainsIn0ZoneRulesTransitions0Overlap !== null) {
            queryParameters = queryParameters.set('datains.in[0].zone.rules.transitions[0].overlap', <any>datainsIn0ZoneRulesTransitions0Overlap);
        }
        if (datainsLessThan !== undefined && datainsLessThan !== null) {
            queryParameters = queryParameters.set('datains.lessThan', <any>datainsLessThan.toISOString());
        }
        if (datainsLessThanOrEqual !== undefined && datainsLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('datains.lessThanOrEqual', <any>datainsLessThanOrEqual.toISOString());
        }
        if (datainsNotEquals !== undefined && datainsNotEquals !== null) {
            queryParameters = queryParameters.set('datains.notEquals', <any>datainsNotEquals.toISOString());
        }
        if (datainsSpecified !== undefined && datainsSpecified !== null) {
            queryParameters = queryParameters.set('datains.specified', <any>datainsSpecified);
        }
        if (dataregistrazioneEquals !== undefined && dataregistrazioneEquals !== null) {
            queryParameters = queryParameters.set('dataregistrazione.equals', <any>dataregistrazioneEquals);
        }
        if (dataregistrazioneGreaterThan !== undefined && dataregistrazioneGreaterThan !== null) {
            queryParameters = queryParameters.set('dataregistrazione.greaterThan', <any>dataregistrazioneGreaterThan);
        }
        if (dataregistrazioneGreaterThanOrEqual !== undefined && dataregistrazioneGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('dataregistrazione.greaterThanOrEqual', <any>dataregistrazioneGreaterThanOrEqual);
        }
        if (dataregistrazioneIn0ChronologyCalendarType !== undefined && dataregistrazioneIn0ChronologyCalendarType !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].chronology.calendarType', <any>dataregistrazioneIn0ChronologyCalendarType);
        }
        if (dataregistrazioneIn0ChronologyId !== undefined && dataregistrazioneIn0ChronologyId !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].chronology.id', <any>dataregistrazioneIn0ChronologyId);
        }
        if (dataregistrazioneIn0DayOfMonth !== undefined && dataregistrazioneIn0DayOfMonth !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfMonth', <any>dataregistrazioneIn0DayOfMonth);
        }
        if (dataregistrazioneIn0DayOfWeek !== undefined && dataregistrazioneIn0DayOfWeek !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfWeek', <any>dataregistrazioneIn0DayOfWeek);
        }
        if (dataregistrazioneIn0DayOfYear !== undefined && dataregistrazioneIn0DayOfYear !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].dayOfYear', <any>dataregistrazioneIn0DayOfYear);
        }
        if (dataregistrazioneIn0EraValue !== undefined && dataregistrazioneIn0EraValue !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].era.value', <any>dataregistrazioneIn0EraValue);
        }
        if (dataregistrazioneIn0LeapYear !== undefined && dataregistrazioneIn0LeapYear !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].leapYear', <any>dataregistrazioneIn0LeapYear);
        }
        if (dataregistrazioneIn0Month !== undefined && dataregistrazioneIn0Month !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].month', <any>dataregistrazioneIn0Month);
        }
        if (dataregistrazioneIn0MonthValue !== undefined && dataregistrazioneIn0MonthValue !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].monthValue', <any>dataregistrazioneIn0MonthValue);
        }
        if (dataregistrazioneIn0Year !== undefined && dataregistrazioneIn0Year !== null) {
            queryParameters = queryParameters.set('dataregistrazione.in[0].year', <any>dataregistrazioneIn0Year);
        }
        if (dataregistrazioneLessThan !== undefined && dataregistrazioneLessThan !== null) {
            queryParameters = queryParameters.set('dataregistrazione.lessThan', <any>dataregistrazioneLessThan);
        }
        if (dataregistrazioneLessThanOrEqual !== undefined && dataregistrazioneLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('dataregistrazione.lessThanOrEqual', <any>dataregistrazioneLessThanOrEqual);
        }
        if (dataregistrazioneNotEquals !== undefined && dataregistrazioneNotEquals !== null) {
            queryParameters = queryParameters.set('dataregistrazione.notEquals', <any>dataregistrazioneNotEquals);
        }
        if (dataregistrazioneSpecified !== undefined && dataregistrazioneSpecified !== null) {
            queryParameters = queryParameters.set('dataregistrazione.specified', <any>dataregistrazioneSpecified);
        }
        if (fornitoreEquals !== undefined && fornitoreEquals !== null) {
            queryParameters = queryParameters.set('fornitore.equals', <any>fornitoreEquals);
        }
        if (fornitoreIn) {
            fornitoreIn.forEach((element) => {
                queryParameters = queryParameters.append('fornitore.in', <any>element);
            })
        }
        if (fornitoreNotEquals !== undefined && fornitoreNotEquals !== null) {
            queryParameters = queryParameters.set('fornitore.notEquals', <any>fornitoreNotEquals);
        }
        if (fornitoreSpecified !== undefined && fornitoreSpecified !== null) {
            queryParameters = queryParameters.set('fornitore.specified', <any>fornitoreSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (idanagraficaEquals !== undefined && idanagraficaEquals !== null) {
            queryParameters = queryParameters.set('idanagrafica.equals', <any>idanagraficaEquals);
        }
        if (idanagraficaGreaterThan !== undefined && idanagraficaGreaterThan !== null) {
            queryParameters = queryParameters.set('idanagrafica.greaterThan', <any>idanagraficaGreaterThan);
        }
        if (idanagraficaGreaterThanOrEqual !== undefined && idanagraficaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idanagrafica.greaterThanOrEqual', <any>idanagraficaGreaterThanOrEqual);
        }
        if (idanagraficaIn) {
            idanagraficaIn.forEach((element) => {
                queryParameters = queryParameters.append('idanagrafica.in', <any>element);
            })
        }
        if (idanagraficaLessThan !== undefined && idanagraficaLessThan !== null) {
            queryParameters = queryParameters.set('idanagrafica.lessThan', <any>idanagraficaLessThan);
        }
        if (idanagraficaLessThanOrEqual !== undefined && idanagraficaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idanagrafica.lessThanOrEqual', <any>idanagraficaLessThanOrEqual);
        }
        if (idanagraficaNotEquals !== undefined && idanagraficaNotEquals !== null) {
            queryParameters = queryParameters.set('idanagrafica.notEquals', <any>idanagraficaNotEquals);
        }
        if (idanagraficaSpecified !== undefined && idanagraficaSpecified !== null) {
            queryParameters = queryParameters.set('idanagrafica.specified', <any>idanagraficaSpecified);
        }
        if (idaziendaEquals !== undefined && idaziendaEquals !== null) {
            queryParameters = queryParameters.set('idazienda.equals', <any>idaziendaEquals);
        }
        if (idaziendaGreaterThan !== undefined && idaziendaGreaterThan !== null) {
            queryParameters = queryParameters.set('idazienda.greaterThan', <any>idaziendaGreaterThan);
        }
        if (idaziendaGreaterThanOrEqual !== undefined && idaziendaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idazienda.greaterThanOrEqual', <any>idaziendaGreaterThanOrEqual);
        }
        if (idaziendaIn) {
            idaziendaIn.forEach((element) => {
                queryParameters = queryParameters.append('idazienda.in', <any>element);
            })
        }
        if (idaziendaLessThan !== undefined && idaziendaLessThan !== null) {
            queryParameters = queryParameters.set('idazienda.lessThan', <any>idaziendaLessThan);
        }
        if (idaziendaLessThanOrEqual !== undefined && idaziendaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idazienda.lessThanOrEqual', <any>idaziendaLessThanOrEqual);
        }
        if (idaziendaNotEquals !== undefined && idaziendaNotEquals !== null) {
            queryParameters = queryParameters.set('idazienda.notEquals', <any>idaziendaNotEquals);
        }
        if (idaziendaSpecified !== undefined && idaziendaSpecified !== null) {
            queryParameters = queryParameters.set('idazienda.specified', <any>idaziendaSpecified);
        }
        if (iddocumentoContains !== undefined && iddocumentoContains !== null) {
            queryParameters = queryParameters.set('iddocumento.contains', <any>iddocumentoContains);
        }
        if (iddocumentoDoesNotContain !== undefined && iddocumentoDoesNotContain !== null) {
            queryParameters = queryParameters.set('iddocumento.doesNotContain', <any>iddocumentoDoesNotContain);
        }
        if (iddocumentoEquals !== undefined && iddocumentoEquals !== null) {
            queryParameters = queryParameters.set('iddocumento.equals', <any>iddocumentoEquals);
        }
        if (iddocumentoIn) {
            iddocumentoIn.forEach((element) => {
                queryParameters = queryParameters.append('iddocumento.in', <any>element);
            })
        }
        if (iddocumentoNotEquals !== undefined && iddocumentoNotEquals !== null) {
            queryParameters = queryParameters.set('iddocumento.notEquals', <any>iddocumentoNotEquals);
        }
        if (iddocumentoSpecified !== undefined && iddocumentoSpecified !== null) {
            queryParameters = queryParameters.set('iddocumento.specified', <any>iddocumentoSpecified);
        }
        if (idsottocontoContains !== undefined && idsottocontoContains !== null) {
            queryParameters = queryParameters.set('idsottoconto.contains', <any>idsottocontoContains);
        }
        if (idsottocontoDoesNotContain !== undefined && idsottocontoDoesNotContain !== null) {
            queryParameters = queryParameters.set('idsottoconto.doesNotContain', <any>idsottocontoDoesNotContain);
        }
        if (idsottocontoEquals !== undefined && idsottocontoEquals !== null) {
            queryParameters = queryParameters.set('idsottoconto.equals', <any>idsottocontoEquals);
        }
        if (idsottocontoIn) {
            idsottocontoIn.forEach((element) => {
                queryParameters = queryParameters.append('idsottoconto.in', <any>element);
            })
        }
        if (idsottocontoNotEquals !== undefined && idsottocontoNotEquals !== null) {
            queryParameters = queryParameters.set('idsottoconto.notEquals', <any>idsottocontoNotEquals);
        }
        if (idsottocontoSpecified !== undefined && idsottocontoSpecified !== null) {
            queryParameters = queryParameters.set('idsottoconto.specified', <any>idsottocontoSpecified);
        }
        if (indirizzoContains !== undefined && indirizzoContains !== null) {
            queryParameters = queryParameters.set('indirizzo.contains', <any>indirizzoContains);
        }
        if (indirizzoDoesNotContain !== undefined && indirizzoDoesNotContain !== null) {
            queryParameters = queryParameters.set('indirizzo.doesNotContain', <any>indirizzoDoesNotContain);
        }
        if (indirizzoEquals !== undefined && indirizzoEquals !== null) {
            queryParameters = queryParameters.set('indirizzo.equals', <any>indirizzoEquals);
        }
        if (indirizzoIn) {
            indirizzoIn.forEach((element) => {
                queryParameters = queryParameters.append('indirizzo.in', <any>element);
            })
        }
        if (indirizzoNotEquals !== undefined && indirizzoNotEquals !== null) {
            queryParameters = queryParameters.set('indirizzo.notEquals', <any>indirizzoNotEquals);
        }
        if (indirizzoSpecified !== undefined && indirizzoSpecified !== null) {
            queryParameters = queryParameters.set('indirizzo.specified', <any>indirizzoSpecified);
        }
        if (intestazioneContains !== undefined && intestazioneContains !== null) {
            queryParameters = queryParameters.set('intestazione.contains', <any>intestazioneContains);
        }
        if (intestazioneDoesNotContain !== undefined && intestazioneDoesNotContain !== null) {
            queryParameters = queryParameters.set('intestazione.doesNotContain', <any>intestazioneDoesNotContain);
        }
        if (intestazioneEquals !== undefined && intestazioneEquals !== null) {
            queryParameters = queryParameters.set('intestazione.equals', <any>intestazioneEquals);
        }
        if (intestazioneIn) {
            intestazioneIn.forEach((element) => {
                queryParameters = queryParameters.append('intestazione.in', <any>element);
            })
        }
        if (intestazioneNotEquals !== undefined && intestazioneNotEquals !== null) {
            queryParameters = queryParameters.set('intestazione.notEquals', <any>intestazioneNotEquals);
        }
        if (intestazioneSpecified !== undefined && intestazioneSpecified !== null) {
            queryParameters = queryParameters.set('intestazione.specified', <any>intestazioneSpecified);
        }
        if (ivaEquals !== undefined && ivaEquals !== null) {
            queryParameters = queryParameters.set('iva.equals', <any>ivaEquals);
        }
        if (ivaGreaterThan !== undefined && ivaGreaterThan !== null) {
            queryParameters = queryParameters.set('iva.greaterThan', <any>ivaGreaterThan);
        }
        if (ivaGreaterThanOrEqual !== undefined && ivaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.greaterThanOrEqual', <any>ivaGreaterThanOrEqual);
        }
        if (ivaIn) {
            ivaIn.forEach((element) => {
                queryParameters = queryParameters.append('iva.in', <any>element);
            })
        }
        if (ivaLessThan !== undefined && ivaLessThan !== null) {
            queryParameters = queryParameters.set('iva.lessThan', <any>ivaLessThan);
        }
        if (ivaLessThanOrEqual !== undefined && ivaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.lessThanOrEqual', <any>ivaLessThanOrEqual);
        }
        if (ivaNotEquals !== undefined && ivaNotEquals !== null) {
            queryParameters = queryParameters.set('iva.notEquals', <any>ivaNotEquals);
        }
        if (ivaSpecified !== undefined && ivaSpecified !== null) {
            queryParameters = queryParameters.set('iva.specified', <any>ivaSpecified);
        }
        if (ivasinoEquals !== undefined && ivasinoEquals !== null) {
            queryParameters = queryParameters.set('ivasino.equals', <any>ivasinoEquals);
        }
        if (ivasinoIn) {
            ivasinoIn.forEach((element) => {
                queryParameters = queryParameters.append('ivasino.in', <any>element);
            })
        }
        if (ivasinoNotEquals !== undefined && ivasinoNotEquals !== null) {
            queryParameters = queryParameters.set('ivasino.notEquals', <any>ivasinoNotEquals);
        }
        if (ivasinoSpecified !== undefined && ivasinoSpecified !== null) {
            queryParameters = queryParameters.set('ivasino.specified', <any>ivasinoSpecified);
        }
        if (mdopagEquals !== undefined && mdopagEquals !== null) {
            queryParameters = queryParameters.set('mdopag.equals', <any>mdopagEquals);
        }
        if (mdopagGreaterThan !== undefined && mdopagGreaterThan !== null) {
            queryParameters = queryParameters.set('mdopag.greaterThan', <any>mdopagGreaterThan);
        }
        if (mdopagGreaterThanOrEqual !== undefined && mdopagGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('mdopag.greaterThanOrEqual', <any>mdopagGreaterThanOrEqual);
        }
        if (mdopagIn) {
            mdopagIn.forEach((element) => {
                queryParameters = queryParameters.append('mdopag.in', <any>element);
            })
        }
        if (mdopagLessThan !== undefined && mdopagLessThan !== null) {
            queryParameters = queryParameters.set('mdopag.lessThan', <any>mdopagLessThan);
        }
        if (mdopagLessThanOrEqual !== undefined && mdopagLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('mdopag.lessThanOrEqual', <any>mdopagLessThanOrEqual);
        }
        if (mdopagNotEquals !== undefined && mdopagNotEquals !== null) {
            queryParameters = queryParameters.set('mdopag.notEquals', <any>mdopagNotEquals);
        }
        if (mdopagSpecified !== undefined && mdopagSpecified !== null) {
            queryParameters = queryParameters.set('mdopag.specified', <any>mdopagSpecified);
        }
        if (ndocContains !== undefined && ndocContains !== null) {
            queryParameters = queryParameters.set('ndoc.contains', <any>ndocContains);
        }
        if (ndocDoesNotContain !== undefined && ndocDoesNotContain !== null) {
            queryParameters = queryParameters.set('ndoc.doesNotContain', <any>ndocDoesNotContain);
        }
        if (ndocEquals !== undefined && ndocEquals !== null) {
            queryParameters = queryParameters.set('ndoc.equals', <any>ndocEquals);
        }
        if (ndocIn) {
            ndocIn.forEach((element) => {
                queryParameters = queryParameters.append('ndoc.in', <any>element);
            })
        }
        if (ndocNotEquals !== undefined && ndocNotEquals !== null) {
            queryParameters = queryParameters.set('ndoc.notEquals', <any>ndocNotEquals);
        }
        if (ndocSpecified !== undefined && ndocSpecified !== null) {
            queryParameters = queryParameters.set('ndoc.specified', <any>ndocSpecified);
        }
        if (ndocSuffEquals !== undefined && ndocSuffEquals !== null) {
            queryParameters = queryParameters.set('ndocSuff.equals', <any>ndocSuffEquals);
        }
        if (ndocSuffGreaterThan !== undefined && ndocSuffGreaterThan !== null) {
            queryParameters = queryParameters.set('ndocSuff.greaterThan', <any>ndocSuffGreaterThan);
        }
        if (ndocSuffGreaterThanOrEqual !== undefined && ndocSuffGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('ndocSuff.greaterThanOrEqual', <any>ndocSuffGreaterThanOrEqual);
        }
        if (ndocSuffIn) {
            ndocSuffIn.forEach((element) => {
                queryParameters = queryParameters.append('ndocSuff.in', <any>element);
            })
        }
        if (ndocSuffLessThan !== undefined && ndocSuffLessThan !== null) {
            queryParameters = queryParameters.set('ndocSuff.lessThan', <any>ndocSuffLessThan);
        }
        if (ndocSuffLessThanOrEqual !== undefined && ndocSuffLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('ndocSuff.lessThanOrEqual', <any>ndocSuffLessThanOrEqual);
        }
        if (ndocSuffNotEquals !== undefined && ndocSuffNotEquals !== null) {
            queryParameters = queryParameters.set('ndocSuff.notEquals', <any>ndocSuffNotEquals);
        }
        if (ndocSuffSpecified !== undefined && ndocSuffSpecified !== null) {
            queryParameters = queryParameters.set('ndocSuff.specified', <any>ndocSuffSpecified);
        }
        if (noteContains !== undefined && noteContains !== null) {
            queryParameters = queryParameters.set('note.contains', <any>noteContains);
        }
        if (noteDoesNotContain !== undefined && noteDoesNotContain !== null) {
            queryParameters = queryParameters.set('note.doesNotContain', <any>noteDoesNotContain);
        }
        if (noteEquals !== undefined && noteEquals !== null) {
            queryParameters = queryParameters.set('note.equals', <any>noteEquals);
        }
        if (noteIn) {
            noteIn.forEach((element) => {
                queryParameters = queryParameters.append('note.in', <any>element);
            })
        }
        if (noteNotEquals !== undefined && noteNotEquals !== null) {
            queryParameters = queryParameters.set('note.notEquals', <any>noteNotEquals);
        }
        if (noteSpecified !== undefined && noteSpecified !== null) {
            queryParameters = queryParameters.set('note.specified', <any>noteSpecified);
        }
        if (opeinsContains !== undefined && opeinsContains !== null) {
            queryParameters = queryParameters.set('opeins.contains', <any>opeinsContains);
        }
        if (opeinsDoesNotContain !== undefined && opeinsDoesNotContain !== null) {
            queryParameters = queryParameters.set('opeins.doesNotContain', <any>opeinsDoesNotContain);
        }
        if (opeinsEquals !== undefined && opeinsEquals !== null) {
            queryParameters = queryParameters.set('opeins.equals', <any>opeinsEquals);
        }
        if (opeinsIn) {
            opeinsIn.forEach((element) => {
                queryParameters = queryParameters.append('opeins.in', <any>element);
            })
        }
        if (opeinsNotEquals !== undefined && opeinsNotEquals !== null) {
            queryParameters = queryParameters.set('opeins.notEquals', <any>opeinsNotEquals);
        }
        if (opeinsSpecified !== undefined && opeinsSpecified !== null) {
            queryParameters = queryParameters.set('opeins.specified', <any>opeinsSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pecContains !== undefined && pecContains !== null) {
            queryParameters = queryParameters.set('pec.contains', <any>pecContains);
        }
        if (pecDoesNotContain !== undefined && pecDoesNotContain !== null) {
            queryParameters = queryParameters.set('pec.doesNotContain', <any>pecDoesNotContain);
        }
        if (pecEquals !== undefined && pecEquals !== null) {
            queryParameters = queryParameters.set('pec.equals', <any>pecEquals);
        }
        if (pecIn) {
            pecIn.forEach((element) => {
                queryParameters = queryParameters.append('pec.in', <any>element);
            })
        }
        if (pecNotEquals !== undefined && pecNotEquals !== null) {
            queryParameters = queryParameters.set('pec.notEquals', <any>pecNotEquals);
        }
        if (pecSpecified !== undefined && pecSpecified !== null) {
            queryParameters = queryParameters.set('pec.specified', <any>pecSpecified);
        }
        if (percentIvaEquals !== undefined && percentIvaEquals !== null) {
            queryParameters = queryParameters.set('percentIva.equals', <any>percentIvaEquals);
        }
        if (percentIvaGreaterThan !== undefined && percentIvaGreaterThan !== null) {
            queryParameters = queryParameters.set('percentIva.greaterThan', <any>percentIvaGreaterThan);
        }
        if (percentIvaGreaterThanOrEqual !== undefined && percentIvaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('percentIva.greaterThanOrEqual', <any>percentIvaGreaterThanOrEqual);
        }
        if (percentIvaIn) {
            percentIvaIn.forEach((element) => {
                queryParameters = queryParameters.append('percentIva.in', <any>element);
            })
        }
        if (percentIvaLessThan !== undefined && percentIvaLessThan !== null) {
            queryParameters = queryParameters.set('percentIva.lessThan', <any>percentIvaLessThan);
        }
        if (percentIvaLessThanOrEqual !== undefined && percentIvaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('percentIva.lessThanOrEqual', <any>percentIvaLessThanOrEqual);
        }
        if (percentIvaNotEquals !== undefined && percentIvaNotEquals !== null) {
            queryParameters = queryParameters.set('percentIva.notEquals', <any>percentIvaNotEquals);
        }
        if (percentIvaSpecified !== undefined && percentIvaSpecified !== null) {
            queryParameters = queryParameters.set('percentIva.specified', <any>percentIvaSpecified);
        }
        if (percritenutaEquals !== undefined && percritenutaEquals !== null) {
            queryParameters = queryParameters.set('percritenuta.equals', <any>percritenutaEquals);
        }
        if (percritenutaGreaterThan !== undefined && percritenutaGreaterThan !== null) {
            queryParameters = queryParameters.set('percritenuta.greaterThan', <any>percritenutaGreaterThan);
        }
        if (percritenutaGreaterThanOrEqual !== undefined && percritenutaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('percritenuta.greaterThanOrEqual', <any>percritenutaGreaterThanOrEqual);
        }
        if (percritenutaIn) {
            percritenutaIn.forEach((element) => {
                queryParameters = queryParameters.append('percritenuta.in', <any>element);
            })
        }
        if (percritenutaLessThan !== undefined && percritenutaLessThan !== null) {
            queryParameters = queryParameters.set('percritenuta.lessThan', <any>percritenutaLessThan);
        }
        if (percritenutaLessThanOrEqual !== undefined && percritenutaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('percritenuta.lessThanOrEqual', <any>percritenutaLessThanOrEqual);
        }
        if (percritenutaNotEquals !== undefined && percritenutaNotEquals !== null) {
            queryParameters = queryParameters.set('percritenuta.notEquals', <any>percritenutaNotEquals);
        }
        if (percritenutaSpecified !== undefined && percritenutaSpecified !== null) {
            queryParameters = queryParameters.set('percritenuta.specified', <any>percritenutaSpecified);
        }
        if (pivaContains !== undefined && pivaContains !== null) {
            queryParameters = queryParameters.set('piva.contains', <any>pivaContains);
        }
        if (pivaDoesNotContain !== undefined && pivaDoesNotContain !== null) {
            queryParameters = queryParameters.set('piva.doesNotContain', <any>pivaDoesNotContain);
        }
        if (pivaEquals !== undefined && pivaEquals !== null) {
            queryParameters = queryParameters.set('piva.equals', <any>pivaEquals);
        }
        if (pivaIn) {
            pivaIn.forEach((element) => {
                queryParameters = queryParameters.append('piva.in', <any>element);
            })
        }
        if (pivaNotEquals !== undefined && pivaNotEquals !== null) {
            queryParameters = queryParameters.set('piva.notEquals', <any>pivaNotEquals);
        }
        if (pivaSpecified !== undefined && pivaSpecified !== null) {
            queryParameters = queryParameters.set('piva.specified', <any>pivaSpecified);
        }
        if (protSuffEquals !== undefined && protSuffEquals !== null) {
            queryParameters = queryParameters.set('protSuff.equals', <any>protSuffEquals);
        }
        if (protSuffGreaterThan !== undefined && protSuffGreaterThan !== null) {
            queryParameters = queryParameters.set('protSuff.greaterThan', <any>protSuffGreaterThan);
        }
        if (protSuffGreaterThanOrEqual !== undefined && protSuffGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('protSuff.greaterThanOrEqual', <any>protSuffGreaterThanOrEqual);
        }
        if (protSuffIn) {
            protSuffIn.forEach((element) => {
                queryParameters = queryParameters.append('protSuff.in', <any>element);
            })
        }
        if (protSuffLessThan !== undefined && protSuffLessThan !== null) {
            queryParameters = queryParameters.set('protSuff.lessThan', <any>protSuffLessThan);
        }
        if (protSuffLessThanOrEqual !== undefined && protSuffLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('protSuff.lessThanOrEqual', <any>protSuffLessThanOrEqual);
        }
        if (protSuffNotEquals !== undefined && protSuffNotEquals !== null) {
            queryParameters = queryParameters.set('protSuff.notEquals', <any>protSuffNotEquals);
        }
        if (protSuffSpecified !== undefined && protSuffSpecified !== null) {
            queryParameters = queryParameters.set('protSuff.specified', <any>protSuffSpecified);
        }
        if (protocolloEquals !== undefined && protocolloEquals !== null) {
            queryParameters = queryParameters.set('protocollo.equals', <any>protocolloEquals);
        }
        if (protocolloGreaterThan !== undefined && protocolloGreaterThan !== null) {
            queryParameters = queryParameters.set('protocollo.greaterThan', <any>protocolloGreaterThan);
        }
        if (protocolloGreaterThanOrEqual !== undefined && protocolloGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('protocollo.greaterThanOrEqual', <any>protocolloGreaterThanOrEqual);
        }
        if (protocolloIn) {
            protocolloIn.forEach((element) => {
                queryParameters = queryParameters.append('protocollo.in', <any>element);
            })
        }
        if (protocolloLessThan !== undefined && protocolloLessThan !== null) {
            queryParameters = queryParameters.set('protocollo.lessThan', <any>protocolloLessThan);
        }
        if (protocolloLessThanOrEqual !== undefined && protocolloLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('protocollo.lessThanOrEqual', <any>protocolloLessThanOrEqual);
        }
        if (protocolloNotEquals !== undefined && protocolloNotEquals !== null) {
            queryParameters = queryParameters.set('protocollo.notEquals', <any>protocolloNotEquals);
        }
        if (protocolloSpecified !== undefined && protocolloSpecified !== null) {
            queryParameters = queryParameters.set('protocollo.specified', <any>protocolloSpecified);
        }
        if (provContains !== undefined && provContains !== null) {
            queryParameters = queryParameters.set('prov.contains', <any>provContains);
        }
        if (provDoesNotContain !== undefined && provDoesNotContain !== null) {
            queryParameters = queryParameters.set('prov.doesNotContain', <any>provDoesNotContain);
        }
        if (provEquals !== undefined && provEquals !== null) {
            queryParameters = queryParameters.set('prov.equals', <any>provEquals);
        }
        if (provIn) {
            provIn.forEach((element) => {
                queryParameters = queryParameters.append('prov.in', <any>element);
            })
        }
        if (provNotEquals !== undefined && provNotEquals !== null) {
            queryParameters = queryParameters.set('prov.notEquals', <any>provNotEquals);
        }
        if (provSpecified !== undefined && provSpecified !== null) {
            queryParameters = queryParameters.set('prov.specified', <any>provSpecified);
        }
        if (ritenutaEquals !== undefined && ritenutaEquals !== null) {
            queryParameters = queryParameters.set('ritenuta.equals', <any>ritenutaEquals);
        }
        if (ritenutaGreaterThan !== undefined && ritenutaGreaterThan !== null) {
            queryParameters = queryParameters.set('ritenuta.greaterThan', <any>ritenutaGreaterThan);
        }
        if (ritenutaGreaterThanOrEqual !== undefined && ritenutaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('ritenuta.greaterThanOrEqual', <any>ritenutaGreaterThanOrEqual);
        }
        if (ritenutaIn) {
            ritenutaIn.forEach((element) => {
                queryParameters = queryParameters.append('ritenuta.in', <any>element);
            })
        }
        if (ritenutaLessThan !== undefined && ritenutaLessThan !== null) {
            queryParameters = queryParameters.set('ritenuta.lessThan', <any>ritenutaLessThan);
        }
        if (ritenutaLessThanOrEqual !== undefined && ritenutaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('ritenuta.lessThanOrEqual', <any>ritenutaLessThanOrEqual);
        }
        if (ritenutaNotEquals !== undefined && ritenutaNotEquals !== null) {
            queryParameters = queryParameters.set('ritenuta.notEquals', <any>ritenutaNotEquals);
        }
        if (ritenutaSpecified !== undefined && ritenutaSpecified !== null) {
            queryParameters = queryParameters.set('ritenuta.specified', <any>ritenutaSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }
        if (tipoContains !== undefined && tipoContains !== null) {
            queryParameters = queryParameters.set('tipo.contains', <any>tipoContains);
        }
        if (tipoDoesNotContain !== undefined && tipoDoesNotContain !== null) {
            queryParameters = queryParameters.set('tipo.doesNotContain', <any>tipoDoesNotContain);
        }
        if (tipoEquals !== undefined && tipoEquals !== null) {
            queryParameters = queryParameters.set('tipo.equals', <any>tipoEquals);
        }
        if (tipoIn) {
            tipoIn.forEach((element) => {
                queryParameters = queryParameters.append('tipo.in', <any>element);
            })
        }
        if (tipoNotEquals !== undefined && tipoNotEquals !== null) {
            queryParameters = queryParameters.set('tipo.notEquals', <any>tipoNotEquals);
        }
        if (tipoSpecified !== undefined && tipoSpecified !== null) {
            queryParameters = queryParameters.set('tipo.specified', <any>tipoSpecified);
        }
        if (totaleEquals !== undefined && totaleEquals !== null) {
            queryParameters = queryParameters.set('totale.equals', <any>totaleEquals);
        }
        if (totaleGreaterThan !== undefined && totaleGreaterThan !== null) {
            queryParameters = queryParameters.set('totale.greaterThan', <any>totaleGreaterThan);
        }
        if (totaleGreaterThanOrEqual !== undefined && totaleGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('totale.greaterThanOrEqual', <any>totaleGreaterThanOrEqual);
        }
        if (totaleIn) {
            totaleIn.forEach((element) => {
                queryParameters = queryParameters.append('totale.in', <any>element);
            })
        }
        if (totaleLessThan !== undefined && totaleLessThan !== null) {
            queryParameters = queryParameters.set('totale.lessThan', <any>totaleLessThan);
        }
        if (totaleLessThanOrEqual !== undefined && totaleLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('totale.lessThanOrEqual', <any>totaleLessThanOrEqual);
        }
        if (totaleNotEquals !== undefined && totaleNotEquals !== null) {
            queryParameters = queryParameters.set('totale.notEquals', <any>totaleNotEquals);
        }
        if (totaleSpecified !== undefined && totaleSpecified !== null) {
            queryParameters = queryParameters.set('totale.specified', <any>totaleSpecified);
        }
        if (totimponibileEquals !== undefined && totimponibileEquals !== null) {
            queryParameters = queryParameters.set('totimponibile.equals', <any>totimponibileEquals);
        }
        if (totimponibileGreaterThan !== undefined && totimponibileGreaterThan !== null) {
            queryParameters = queryParameters.set('totimponibile.greaterThan', <any>totimponibileGreaterThan);
        }
        if (totimponibileGreaterThanOrEqual !== undefined && totimponibileGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('totimponibile.greaterThanOrEqual', <any>totimponibileGreaterThanOrEqual);
        }
        if (totimponibileIn) {
            totimponibileIn.forEach((element) => {
                queryParameters = queryParameters.append('totimponibile.in', <any>element);
            })
        }
        if (totimponibileLessThan !== undefined && totimponibileLessThan !== null) {
            queryParameters = queryParameters.set('totimponibile.lessThan', <any>totimponibileLessThan);
        }
        if (totimponibileLessThanOrEqual !== undefined && totimponibileLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('totimponibile.lessThanOrEqual', <any>totimponibileLessThanOrEqual);
        }
        if (totimponibileNotEquals !== undefined && totimponibileNotEquals !== null) {
            queryParameters = queryParameters.set('totimponibile.notEquals', <any>totimponibileNotEquals);
        }
        if (totimponibileSpecified !== undefined && totimponibileSpecified !== null) {
            queryParameters = queryParameters.set('totimponibile.specified', <any>totimponibileSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ApolloDocumentDTO>>('get',`${this.basePath}/api/apollo-documents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getApolloDocument
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApolloDocumentUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentDTO>;
    public getApolloDocumentUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentDTO>>;
    public getApolloDocumentUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentDTO>>;
    public getApolloDocumentUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getApolloDocumentUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ApolloDocumentDTO>('get',`${this.basePath}/api/apollo-documents/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateApolloDocument
     * 
     * @param body apolloDocumentDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateApolloDocumentUsingPUT(body: ApolloDocumentDTO, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentDTO>;
    public updateApolloDocumentUsingPUT(body: ApolloDocumentDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentDTO>>;
    public updateApolloDocumentUsingPUT(body: ApolloDocumentDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentDTO>>;
    public updateApolloDocumentUsingPUT(body: ApolloDocumentDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateApolloDocumentUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ApolloDocumentDTO>('put',`${this.basePath}/api/apollo-documents`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
